import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const defaultUserForm = {
  name: '',
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  role: 'student',
  bio: '',
  assigned_course_ids: [],
  department: '',
  position: '',
  manager_id: '',
  is_manager: false,
};

const defaultEditUserForm = {
  id: '',
  name: '',
  firstname: '',
  lastname: '',
  email: '',
  role: 'student',
  bio: '',
  profile_photo_url: '',
  phone_number: '',
  date_of_birth: '',
  address: '',
  city: '',
  province_state: '',
  postal_code: '',
  country: '',
  current_school: '',
  grade_level: '',
  parent_guardian_name: '',
  parent_guardian_email: '',
  parent_guardian_phone: '',
  parent_guardian: { first_name: '', last_name: '', email: '', cell_phone: '', work_phone: '', home_phone: '' },
  emergency_contact_name: '',
  emergency_contact_relationship: '',
  emergency_contact_phone: '',
  emergency_contact: { name: '', phone_number: '' },
  secondary_contact: { name: '', phone_number: '' },
  enrollment_status: 'active',
  assigned_teacher_id: '',
  accountStatus: 'active',
  specialization: '',
  qualifications: '',
  employment_status: 'full_time',
  teaching_availability: '',
  assigned_course_ids: [],
  enrolled_courses: [],
  department: '',
  position: '',
  manager_id: '',
  is_manager: false,
};

const defaultCourseForm = {
  catalog_group: 'Robotics',
  subject: 'Robotics & Engineering',
  title: '',
  description: '',
  category: 'Beginner',
  duration: 'Approximately 4 Months',
  level: 'Beginner',
  difficulty_level: 'Beginner',
  best_for: '',
  prerequisites: '',
  learning_outcomes: '',
  projects: '',
  career_paths: '',
  price: '600.99',
  is_free: false,
  estimated_hours: '40',
  certificate_available: true,
  teacher_id: '',
  teacher_ids: [],
  instructor_bio: '',
  learning_objectives: '',
  thumbnail_url: '',
  status: 'published',
  availability_status: 'open',
  delivery_mode: 'online',
};

const CATALOG_GROUP_OPTIONS = [
  { value: 'Robotics', label: 'Robotics' },
  { value: 'Coding', label: 'Coding' },
  { value: 'Artificial Intelligence', label: 'Artificial Intelligence' },
  { value: 'Cloud Computing', label: 'Cloud Computing' },
  { value: 'Cybersecurity', label: 'Cybersecurity' },
  { value: 'Engineering', label: 'Engineering' },
  { value: 'CAD', label: 'CAD' },
  { value: 'Mathematics', label: 'Mathematics' },
  { value: 'French', label: 'French' },
  { value: 'STEM', label: 'STEM' },
  { value: 'K.R.A Before & After-School Clubs', label: 'K.R.A Before & After-School Clubs' },
  { value: 'Career', label: 'Career' },
];

const CATEGORY_OPTIONS_BY_GROUP = {
  Robotics: [
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' },
    { value: 'Specialized', label: 'Specialized' },
    { value: 'Project', label: 'Project' },
    { value: 'Competition', label: 'Competition' },
  ],
  Coding: [
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' },
    { value: 'Web Development', label: 'Web Development' },
    { value: 'Mobile Development', label: 'Mobile Development' },
  ],
  'Artificial Intelligence': [
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' },
    { value: 'Data Science', label: 'Data Science' },
  ],
  'Cloud Computing': [
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' },
    { value: 'DevOps', label: 'DevOps' },
  ],
  Cybersecurity: [
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' },
  ],
  Engineering: [
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' },
  ],
  CAD: [
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' },
  ],
  Mathematics: [
    { value: 'Grade 1-8', label: 'Grade 1-8' },
    { value: 'High School', label: 'High School' },
    { value: 'Advanced Mathematics', label: 'Advanced Mathematics' },
  ],
  French: [
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' },
    { value: 'Immigration', label: 'Immigration' },
  ],
  STEM: [
    { value: 'Ages 6-9', label: 'Ages 6-9' },
    { value: 'Ages 10-13', label: 'Ages 10-13' },
    { value: 'Ages 14-18', label: 'Ages 14-18' },
  ],
  'K.R.A Before & After-School Clubs': [
    { value: 'Care Programs', label: 'Care Programs' },
    { value: 'Sports & Recreation', label: 'Sports & Recreation' },
    { value: 'STEM & Technology', label: 'STEM & Technology' },
    { value: 'Arts & Creativity', label: 'Arts & Creativity' },
    { value: 'Games & Thinking Skills', label: 'Games & Thinking Skills' },
    { value: 'Business & Life Skills', label: 'Business & Life Skills' },
    { value: 'Language & Academic Clubs', label: 'Language & Academic Clubs' },
  ],
  Career: [
    { value: 'Career Path', label: 'Career Path' },
    { value: 'Certification', label: 'Certification' },
    { value: 'Interview Preparation', label: 'Interview Preparation' },
  ],
};

const ROBOTICS_CATEGORY_OPTIONS = CATEGORY_OPTIONS_BY_GROUP.Robotics;

const AVAILABILITY_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'closed', label: 'Closed' },
  { value: 'coming_soon', label: 'Coming Soon' },
  { value: 'waitlist', label: 'Waitlist' },
  { value: 'archived', label: 'Archived' },
];

const SUBJECT_OPTIONS = [
  { value: 'Robotics & Engineering', label: 'Robotics & Engineering' },
  { value: 'Coding & Programming', label: 'Coding & Programming' },
  { value: 'Artificial Intelligence', label: 'Artificial Intelligence' },
  { value: 'Mathematics', label: 'Mathematics' },
  { value: 'Science', label: 'Science' },
  { value: 'Languages', label: 'Languages' },
  { value: 'Business', label: 'Business' },
  { value: 'Creative Programs', label: 'Creative Programs' },
  { value: 'CAD & 3D Design', label: 'CAD & 3D Design' },
  { value: 'Engineering', label: 'Engineering' },
];

const splitLines = (value) => String(value || '').split('\n').map((item) => item.trim()).filter(Boolean);

const defaultClassForm = {
  name: '',
  teacher_id: '',
  course_id: '',
  date: '',
  start_time: '',
  end_time: '',
  meeting_link: '',
  student_ids: [],
  status: 'scheduled',
};

const defaultMessageForm = {
  subject: '',
  content: '',
  recipient_type: 'all_students',
  user_id: '',
  course_id: '',
  class_id: '',
  channels: ['platform'],
  priority: 'information',
};

const defaultNewsletterForm = {
  subject: '',
  content: '<p></p>',
  recipients: 'all_users',
  preview_mode: false,
  send_immediately: true,
  selected_groups: [],
  scheduled_for: '',
};

const defaultAnnouncementForm = {
  title: '',
  content: '',
  placements: ['homepage'],
  priority: 'information',
  start_date: '',
  end_date: '',
  is_active: true,
};

const defaultMeetingForm = {
  title: '',
  description: '',
  meeting_at: '',
  platform: 'Google Meet',
  meeting_url: '',
  employee_ids: [],
  send_to_all: false,
};

const defaultJobForm = {
  title: '',
  company: 'K.R.A Initiative LTD',
  location: 'Greater Toronto Area, Ontario, Canada',
  employment_type: 'Part-Time / Contract',
  remote_hybrid_status: 'Remote / Hybrid',
  description: '',
  responsibilities: '',
  qualifications: '',
  preferred_qualifications: '',
  compensation: '',
  benefits: '',
  application_requirements: '',
  application_deadline: '',
  status: 'open',
};

const defaultHackathonForm = {
  title: '',
  slug: '',
  tagline: '',
  description: '',
  theme: '',
  format: 'In Person / Hybrid',
  age_requirement: 'Children & youth ages 8-18',
  event_date: '',
  application_deadline: '',
  difficulty: 'beginner',
  first_prize: '',
  second_prize: '',
  third_prize: '',
  application_instructions: '',
  image_url: '',
  location: 'Toronto, Canada',
  published: false,
};

const contentSections = ['homepage', 'about', 'pricing', 'course_descriptions', 'teacher_profiles', 'student_resources'];

const formatAttachmentDate = (value) => {
  if (!value) return 'Unknown date';
  try {
    return new Date(value).toLocaleString();
  } catch (error) {
    return String(value);
  }
};

const formatAttachmentSize = (bytes) => {
  const value = Number(bytes || 0);
  if (!Number.isFinite(value) || value <= 0) return '0 B';
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
  return `${(value / (1024 * 1024)).toFixed(1)} MB`;
};

const isImageAttachment = (attachment) => String(attachment?.content_type || '').toLowerCase().startsWith('image/');
const isVideoAttachment = (attachment) => String(attachment?.content_type || '').toLowerCase().startsWith('video/');

const getAttachmentTypeLabel = (attachment) => {
  if (isImageAttachment(attachment)) return 'Image';
  if (isVideoAttachment(attachment)) return 'Video';
  const type = String(attachment?.content_type || '').toLowerCase();
  if (type.includes('pdf')) return 'PDF';
  if (type.includes('sheet') || type.includes('excel') || type.includes('csv')) return 'Spreadsheet';
  if (type.includes('word') || type.includes('document')) return 'Document';
  if (type.includes('presentation') || type.includes('powerpoint')) return 'Presentation';
  if (type.includes('zip') || type.includes('compressed')) return 'Archive';
  if (type.includes('text')) return 'Text';
  return 'File';
};

const resolveAttachmentUrl = (attachment, preview = false) => {
  if (!attachment) return '';
  if (preview && attachment.preview_url) return `${BACKEND_URL}${attachment.preview_url}`;
  if (attachment.download_url) return `${BACKEND_URL}${attachment.download_url}`;
  if (attachment.url) {
    if (/^https?:\/\//i.test(attachment.url)) return attachment.url;
    return `${BACKEND_URL}${attachment.url.startsWith('/') ? attachment.url : `/${attachment.url}`}`;
  }
  return '';
};

const adminDownloadAttachment = (attachment, preview = false) => {
  const href = resolveAttachmentUrl(attachment, preview);
  if (!href) return;
  const token = localStorage.getItem('token');
  const sep = href.includes('?') ? '&' : '?';
  const url = token ? `${href}${sep}access_token=${encodeURIComponent(token)}` : href;
  if (preview) {
    window.open(url, '_blank', 'noreferrer noopener');
  } else {
    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;';
    iframe.src = url;
    document.body.appendChild(iframe);
    setTimeout(() => { if (document.body.contains(iframe)) document.body.removeChild(iframe); }, 30000);
  }
};

function LabeledInput({ label, value, onChange, type = 'text', placeholder, error, textarea, rows }) {
  const baseClass = `w-full bg-gray-800 text-white px-4 py-3 rounded-lg border ${error ? 'border-red-500' : 'border-gray-600'}`;
  return (
    <div>
      {label && <label className="block text-xs font-semibold text-gray-400 mb-1 uppercase tracking-wide">{label}</label>}
      {textarea ? (
        <textarea value={value || ''} onChange={(e) => onChange(e.target.value)} rows={rows || 3} className={baseClass} placeholder={placeholder} />
      ) : (
        <input type={type} value={value || ''} onChange={(e) => onChange(e.target.value)} className={baseClass} placeholder={placeholder} />
      )}
      {error && <div className="text-xs text-red-400 mt-1">{error}</div>}
    </div>
  );
}

function LabeledSelect({ label, value, onChange, options }) {
  return (
    <div>
      {label && <label className="block text-xs font-semibold text-gray-400 mb-1 uppercase tracking-wide">{label}</label>}
      <select value={value || ''} onChange={(e) => onChange(e.target.value)} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
        {options.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
    </div>
  );
}


function AssignedCoursesPicker({ courses, selectedIds, onChange, searchValue, onSearchChange, sortOrder, onSortChange, error }) {
  const filteredCourses = (courses || [])
    .filter((course) => {
      const searchTerm = searchValue.trim().toLowerCase();
      if (!searchTerm) return true;
      const haystack = [course.title, course.category, course.subject, course.teacher_name, course.instructor, course.level]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      return haystack.includes(searchTerm);
    })
    .sort((a, b) => {
      const titleA = (a.title || '').toLowerCase();
      const titleB = (b.title || '').toLowerCase();
      return sortOrder === 'za' ? titleB.localeCompare(titleA) : titleA.localeCompare(titleB);
    });

  return (
    <div className="space-y-3 rounded-2xl border border-yellow-400/20 bg-black/20 p-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-bold text-yellow-400 uppercase tracking-wide">Assigned Courses</h3>
        <span className="text-xs text-gray-400">{(selectedIds || []).length} selected</span>
      </div>
      <p className="text-xs text-gray-400">A teacher must always keep at least one active course assigned.</p>
      <div className="flex flex-col md:flex-row gap-2">
        <input
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          className="flex-1 bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600"
          placeholder="Search courses by title, category, or instructor"
        />
        <select value={sortOrder} onChange={(e) => onSortChange(e.target.value)} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
          <option value="az">Sort A - Z</option>
          <option value="za">Sort Z - A</option>
        </select>
      </div>
      <div className="max-h-56 overflow-y-auto space-y-2 pr-1">
        {filteredCourses.length === 0 && (
          <div className="text-sm text-gray-500 px-2 py-3">No courses match your search.</div>
        )}
        {filteredCourses.map((course) => {
          const checked = (selectedIds || []).includes(course.id);
          return (
            <label key={course.id} className="flex items-start gap-3 rounded-xl border border-gray-700 bg-gray-900 px-3 py-2 text-sm text-gray-200">
              <input
                type="checkbox"
                checked={checked}
                onChange={(e) => {
                  const nextIds = e.target.checked
                    ? [...new Set([...(selectedIds || []), course.id])]
                    : (selectedIds || []).filter((courseId) => courseId !== course.id);
                  onChange(nextIds);
                }}
                className="mt-1 h-4 w-4 rounded border-gray-500 text-yellow-500 focus:ring-yellow-500"
              />
              <span>
                <span className="block font-medium text-white">{course.title}</span>
                <span className="block text-xs text-gray-400">{course.category || 'General'} • {course.teacher_name || course.instructor || 'Unassigned'}</span>
              </span>
            </label>
          );
        })}
      </div>
      {error && <div className="text-xs text-red-400">{error}</div>}
    </div>
  );
}


export default function AdminPortal({ user, onPageChange }) {
  const [activeTab, setActiveTab] = useState('overview');
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [dashboard, setDashboard] = useState(null);
  const [users, setUsers] = useState([]);
  const [courses, setCourses] = useState([]);
  const [classes, setClasses] = useState([]);
  const [enrollments, setEnrollments] = useState([]);
  const [attendance, setAttendance] = useState({ summary: {}, records: [], by_teacher: [], by_course: [], by_student: [] });
  const [payments, setPayments] = useState({ summary: {}, transactions: [] });
  const [paymentTransactions, setPaymentTransactions] = useState([]);
  const [newsletters, setNewsletters] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [jobApplications, setJobApplications] = useState([]);
  const [hackathons, setHackathons] = useState([]);
  const [hackathonApplications, setHackathonApplications] = useState([]);
  const [hackathonApplicationStats, setHackathonApplicationStats] = useState({ total: 0, new: 0, under_review: 0, reviewed: 0, shortlisted: 0, accepted: 0, rejected: 0 });
  const [content, setContent] = useState({});
  const [settings, setSettings] = useState({
    school_information: {},
    contact_information: {},
    email_settings: {},
    enrollment_settings: {},
    certificate_settings: {},
    branding: {},
  });
  const [auditLogs, setAuditLogs] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [employeeTasks, setEmployeeTasks] = useState([]);
  const [employeeMeetings, setEmployeeMeetings] = useState([]);
  const [employeeInbox, setEmployeeInbox] = useState([]);
  const [employeeConversationDetail, setEmployeeConversationDetail] = useState(null);
  const [employeeConversationMessages, setEmployeeConversationMessages] = useState([]);
  const [selectedEmployeeConversationId, setSelectedEmployeeConversationId] = useState('');
  const [employeeConversationReply, setEmployeeConversationReply] = useState('');
  const [employeeConversationSearch, setEmployeeConversationSearch] = useState('');
  const [employeeMessageUploadProgress, setEmployeeMessageUploadProgress] = useState(0);
  const [employeeMessageAttachmentUploading, setEmployeeMessageAttachmentUploading] = useState(false);
  const [conversationReplyAttachmentDraft, setConversationReplyAttachmentDraft] = useState([]);
  const [conversationReplyAttachmentUploading, setConversationReplyAttachmentUploading] = useState(false);
  const [adminConversationUsers, setAdminConversationUsers] = useState([]);
  const [conversationRecipientRoleFilter, setConversationRecipientRoleFilter] = useState('employee');
  const [conversationRecipientId, setConversationRecipientId] = useState('');
  const [conversationSubjectDraft, setConversationSubjectDraft] = useState('');
  const [conversationStartDraft, setConversationStartDraft] = useState('');
  const [conversationStartAttachmentDraft, setConversationStartAttachmentDraft] = useState([]);
  const [conversationStartAttachmentUploading, setConversationStartAttachmentUploading] = useState(false);
  const [editingMsgId, setEditingMsgId] = useState('');
  const [editingMsgText, setEditingMsgText] = useState('');
  const [deptForm, setDeptForm] = useState({ name: '', description: '' });
  const [taskAssignForm, setTaskAssignForm] = useState({ employee_id: '', title: '', description: '', priority: 'medium', start_date: '', deadline: '', status: 'pending', attachments: [] });
  const [taskAttachmentUploading, setTaskAttachmentUploading] = useState(false);
  const [taskAttachmentUpdatingId, setTaskAttachmentUpdatingId] = useState('');
  const [taskEditById, setTaskEditById] = useState({});
  const [savingTaskEditId, setSavingTaskEditId] = useState('');
  const [employeeBroadcastForm, setEmployeeBroadcastForm] = useState({
    title: '',
    message: '',
    employee_ids: [],
    send_to_all_employees: false,
    attachment_ids: [],
  });
  const [meetingForm, setMeetingForm] = useState(defaultMeetingForm);
  const [userForm, setUserForm] = useState(defaultUserForm);
  const [courseForm, setCourseForm] = useState(defaultCourseForm);
  const [classForm, setClassForm] = useState(defaultClassForm);
  const [messageForm, setMessageForm] = useState(defaultMessageForm);
  const [newsletterForm, setNewsletterForm] = useState(defaultNewsletterForm);
  const [announcementForm, setAnnouncementForm] = useState(defaultAnnouncementForm);
  const [jobForm, setJobForm] = useState(defaultJobForm);
  const [hackathonForm, setHackathonForm] = useState(defaultHackathonForm);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedHackathonId, setSelectedHackathonId] = useState('');
  const [editingHackathonId, setEditingHackathonId] = useState('');
  const [selectedHackathonApplication, setSelectedHackathonApplication] = useState(null);
  const [selectedHackathonApplicationIds, setSelectedHackathonApplicationIds] = useState([]);
  const [hackathonSearch, setHackathonSearch] = useState('');
  const [hackathonStatusFilter, setHackathonStatusFilter] = useState('');
  const [hackathonApplicationsLoading, setHackathonApplicationsLoading] = useState(false);
  const [hackathonEmailForm, setHackathonEmailForm] = useState({ subject: '', message: '' });
  const [hackathonImageUploading, setHackathonImageUploading] = useState(false);
  const [userSearch, setUserSearch] = useState('');
  const [userRoleFilter, setUserRoleFilter] = useState('');
  const [parentSearch, setParentSearch] = useState('');
  const [selectedParent, setSelectedParent] = useState(null);
  const [contentDrafts, setContentDrafts] = useState({});
  const [teacherCourseSearch, setTeacherCourseSearch] = useState('');
  const [teacherCourseSort, setTeacherCourseSort] = useState('az');
  const [editCourseSearch, setEditCourseSearch] = useState('');
  const [editCourseSort, setEditCourseSort] = useState('az');
  const [editErrors, setEditErrors] = useState({});
  const [savingUser, setSavingUser] = useState(false);
  const [photoUploading, setPhotoUploading] = useState(false);
  const [courseGroupFilter, setCourseGroupFilter] = useState('all');
  const [courseCategoryFilter, setCourseCategoryFilter] = useState('all');

  const isAdmin = (user?.role || '').toLowerCase() === 'admin';
  const teachers = users.filter((item) => ['teacher', 'admin', 'mentor'].includes((item.role || '').toLowerCase()));
  const students = users.filter((item) => (item.role || '').toLowerCase() === 'student');
  const parentDirectory = students
    .map((student) => {
      const parent = student.parent_guardian || {
        first_name: student.parent_guardian_name || '',
        last_name: '',
        email: student.parent_guardian_email || '',
        cell_phone: student.parent_guardian_phone || '',
      };
      return { student, parent };
    })
    .filter(({ parent }) => Object.values(parent || {}).some(Boolean));
  const normalizedParentSearch = parentSearch.trim().toLowerCase();
  const filteredParentDirectory = parentDirectory.filter(({ student, parent }) => {
    if (!normalizedParentSearch) return true;
    return [
      parent.first_name,
      parent.last_name,
      parent.email,
      parent.cell_phone,
      parent.work_phone,
      parent.home_phone,
      student.name,
      student.email,
    ].filter(Boolean).join(' ').toLowerCase().includes(normalizedParentSearch);
  });
  const conversationRecipients = (adminConversationUsers || []).filter((entry) => {
    const role = String(entry?.role || '').toLowerCase();
    if (conversationRecipientRoleFilter === 'teacher') return role === 'teacher' || role === 'mentor';
    return role === conversationRecipientRoleFilter;
  });
  const selectedCatalogGroup = courseForm.catalog_group || 'Robotics';
  const selectableCategoryOptions = CATEGORY_OPTIONS_BY_GROUP[selectedCatalogGroup] || ROBOTICS_CATEGORY_OPTIONS;
  const availableCourseGroups = Array.from(new Set(courses.map((course) => String(course.catalog_group || course.catalogGroup || '').trim()).filter(Boolean))).sort((a, b) => a.localeCompare(b));
  const availableCourseCategories = Array.from(new Set(courses.map((course) => String(course.category || '').trim()).filter(Boolean))).sort((a, b) => a.localeCompare(b));
  const selectedHackathon = hackathons.find((entry) => entry.id === selectedHackathonId) || null;
  const editingHackathon = hackathons.find((entry) => entry.id === editingHackathonId) || null;

  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'users', label: 'Users' },
    { id: 'parents', label: 'Parents / Guardians' },
    { id: 'employees', label: 'Employees' },
    { id: 'courses', label: 'Courses' },
    { id: 'jobs', label: 'Jobs' },
    { id: 'hackathons', label: 'Hackathons' },
    { id: 'classes', label: 'Classes' },
    { id: 'enrollments', label: 'Enrollments' },
    { id: 'communication', label: 'Communication' },
    { id: 'attendance', label: 'Attendance' },
    { id: 'finance', label: 'Finance' },
    { id: 'content', label: 'Content' },
    { id: 'settings', label: 'Settings' },
    { id: 'audit', label: 'Audit Logs' },
    { id: 'certificates', label: 'Certificates' },
  ];

  const setFeedback = (message, isError = false) => {
    if (isError) {
      setError(message);
      setStatus('');
    } else {
      setStatus(message);
      setError('');
    }
  };

  const getErrorMessage = (requestError, fallback = 'Something went wrong') => {
    const detail = requestError?.response?.data?.detail;
    if (!detail) return fallback;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
      return detail
        .map((item) => {
          if (typeof item === 'string') return item;
          const field = Array.isArray(item?.loc) ? item.loc[item.loc.length - 1] : null;
          return field ? `${field}: ${item.msg}` : item?.msg;
        })
        .filter(Boolean)
        .join('; ') || fallback;
    }
    if (typeof detail === 'object') return detail.msg || fallback;
    return fallback;
  };

  const refreshPortal = async () => {
    try {
      setLoading(true);
      const [dashboardRes, usersRes, coursesRes, jobsRes, hackathonsRes, applicationsRes, classesRes, enrollmentsRes, attendanceRes, paymentsRes, paymentTransactionsRes, newslettersRes, announcementsRes, contentRes, settingsRes, auditRes] = await Promise.all([
        axios.get(`${API}/admin/dashboard`),
        axios.get(`${API}/admin/users`, { params: { role: userRoleFilter || undefined, search: userSearch || undefined } }),
        axios.get(`${API}/admin/courses`),
        axios.get(`${API}/admin/jobs`),
        axios.get(`${API}/admin/hackathons`),
        axios.get(`${API}/admin/job-applications`),
        axios.get(`${API}/admin/classes`),
        axios.get(`${API}/admin/enrollments`),
        axios.get(`${API}/admin/attendance/overview`),
        axios.get(`${API}/admin/payments/overview`),
        axios.get(`${API}/admin/payments/transactions`),
        axios.get(`${API}/admin/newsletters`),
        axios.get(`${API}/admin/announcements`),
        axios.get(`${API}/admin/content`),
        axios.get(`${API}/admin/settings`),
        axios.get(`${API}/admin/audit-logs`),
      ]);
      setDashboard(dashboardRes.data || null);
      setUsers(usersRes.data?.users || []);
      setCourses(coursesRes.data?.courses || []);
      setJobs(jobsRes.data?.jobs || []);
      setHackathons(hackathonsRes.data?.hackathons || []);
      setJobApplications(applicationsRes.data?.applications || []);
      setClasses(classesRes.data?.classes || []);
      setEnrollments(enrollmentsRes.data?.enrollments || []);
      setAttendance(attendanceRes.data || { summary: {}, records: [] });
      setPayments(paymentsRes.data || { summary: {}, transactions: [] });
      setPaymentTransactions(paymentTransactionsRes.data?.transactions || []);
      setNewsletters(newslettersRes.data?.newsletters || []);
      setAnnouncements(announcementsRes.data?.announcements || []);
      setContent(contentRes.data?.content || {});
      setSettings(settingsRes.data?.settings || settings);
      setAuditLogs(auditRes.data?.logs || []);
      const nextDrafts = {};
      contentSections.forEach((section) => {
        nextDrafts[section] = {
          title: contentRes.data?.content?.[section]?.title || '',
          body: contentRes.data?.content?.[section]?.body || '',
        };
      });
      setContentDrafts(nextDrafts);
      setError('');
      try {
        const [deptRes, taskRes, meetingRes, inboxRes, conversationUsersRes] = await Promise.all([
          axios.get(`${API}/admin/departments`),
          axios.get(`${API}/admin/employees/tasks`),
          axios.get(`${API}/admin/employees/meetings`),
          axios.get(`${API}/employee/conversations`),
          axios.get(`${API}/employee/conversations/users`, {
            params: {
              include_roles: 'student,teacher,mentor,employee,admin',
              limit: 2000,
            },
          }),
        ]);
        setDepartments(deptRes.data?.departments || []);
        setEmployeeTasks(taskRes.data?.tasks || []);
        setEmployeeMeetings(meetingRes.data?.meetings || []);
        setEmployeeInbox(inboxRes.data?.conversations || []);
        setAdminConversationUsers(conversationUsersRes.data?.users || []);
      } catch (employeePortalError) {
        // Non-critical widgets — don't block the rest of the admin portal.
      }
    } catch (loadError) {
      setFeedback(getErrorMessage(loadError, 'Failed to load admin portal'), true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAdmin) {
      refreshPortal();
    }
  }, [isAdmin, userRoleFilter, userSearch]);

  useEffect(() => {
    if (!hackathons.length) {
      setSelectedHackathonId('');
      setEditingHackathonId('');
      setHackathonForm(defaultHackathonForm);
      return;
    }
    if (!hackathons.some((entry) => entry.id === selectedHackathonId)) {
      setSelectedHackathonId(hackathons[0].id || '');
    }
    if (editingHackathonId && !hackathons.some((entry) => entry.id === editingHackathonId)) {
      setEditingHackathonId('');
    }
  }, [hackathons, selectedHackathonId, editingHackathonId]);

  useEffect(() => {
    if (!editingHackathon) {
      setHackathonForm(defaultHackathonForm);
      return;
    }
    setHackathonForm({
      title: editingHackathon.title || '',
      slug: editingHackathon.slug || '',
      tagline: editingHackathon.tagline || '',
      description: editingHackathon.description || '',
      theme: editingHackathon.theme || '',
      format: editingHackathon.format || 'In Person / Hybrid',
      age_requirement: editingHackathon.age_requirement || 'Children & youth ages 8-18',
      event_date: editingHackathon.event_date ? new Date(editingHackathon.event_date).toISOString().slice(0, 16) : '',
      application_deadline: editingHackathon.application_deadline ? new Date(editingHackathon.application_deadline).toISOString().slice(0, 16) : '',
      difficulty: editingHackathon.difficulty || 'beginner',
      first_prize: editingHackathon.first_prize || '',
      second_prize: editingHackathon.second_prize || '',
      third_prize: editingHackathon.third_prize || '',
      application_instructions: (editingHackathon.application_instructions || []).join('\n'),
      image_url: editingHackathon.image_url || '',
      location: editingHackathon.location || 'Toronto, Canada',
      published: Boolean(editingHackathon.published),
    });
  }, [editingHackathon]);

  useEffect(() => {
    const filtered = (adminConversationUsers || []).filter((entry) => {
      const role = String(entry?.role || '').toLowerCase();
      if (conversationRecipientRoleFilter === 'teacher') return role === 'teacher' || role === 'mentor';
      return role === conversationRecipientRoleFilter;
    });
    if (!filtered.length) {
      setConversationRecipientId('');
      return;
    }
    if (!filtered.some((entry) => entry.id === conversationRecipientId)) {
      setConversationRecipientId(filtered[0].id || '');
    }
  }, [adminConversationUsers, conversationRecipientRoleFilter, conversationRecipientId]);

  useEffect(() => {
    if (!isAdmin || activeTab !== 'hackathons' || !selectedHackathonId) return;
    const loadHackathonApplications = async () => {
      try {
        setHackathonApplicationsLoading(true);
        const response = await axios.get(`${API}/admin/hackathons/${selectedHackathonId}/applications`, {
          params: {
            search: hackathonSearch.trim() || undefined,
            status: hackathonStatusFilter || undefined,
          },
        });
        setHackathonApplications(response.data?.applications || []);
        setHackathonApplicationStats(response.data?.stats || { total: 0, new: 0, under_review: 0, reviewed: 0, shortlisted: 0, accepted: 0, rejected: 0 });
        setSelectedHackathonApplicationIds((current) => current.filter((id) => (response.data?.applications || []).some((entry) => entry.id === id)));
        if (selectedHackathonApplication && !(response.data?.applications || []).some((entry) => entry.id === selectedHackathonApplication.id)) {
          setSelectedHackathonApplication(null);
        }
      } catch (requestError) {
        setFeedback(getErrorMessage(requestError, 'Unable to load hackathon applications'), true);
      } finally {
        setHackathonApplicationsLoading(false);
      }
    };
    loadHackathonApplications();
  }, [isAdmin, activeTab, selectedHackathonId, hackathonSearch, hackathonStatusFilter]);

  const formatHackathonDate = (value) => {
    if (!value) return 'N/A';
    try {
      return new Date(value).toLocaleString();
    } catch (error) {
      return String(value);
    }
  };

  const handleCreateUser = async () => {
    try {
      const role = (userForm.role || '').toLowerCase();
      const rawEmail = String(userForm.email || '').trim().toLowerCase();
      const email = (role === 'teacher' || role === 'employee') && rawEmail && !rawEmail.includes('@')
        ? `${rawEmail}@krainitiative.com`
        : rawEmail;
      const assignedCourseIds = role === 'teacher' ? (userForm.assigned_course_ids || []).filter(Boolean) : [];
      if ((role === 'teacher' || role === 'employee') && email && !email.endsWith('@krainitiative.com')) {
        setFeedback(`${role === 'teacher' ? 'Teacher' : 'Employee'} email must end with @krainitiative.com`, true);
        return;
      }
      if (role === 'teacher' && assignedCourseIds.length === 0) {
        setFeedback('Assign at least one course before creating a teacher account', true);
        return;
      }
      if (!String(userForm.password || '').trim() || userForm.password.length < 8) {
        setFeedback('Password must be at least 8 characters', true);
        return;
      }
      await axios.post(`${API}/admin/users`, { ...userForm, email, assigned_course_ids: assignedCourseIds });
      setUserForm(defaultUserForm);
      setTeacherCourseSearch('');
      setFeedback('User created');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to create user'), true);
    }
  };

  const openEditUser = (entry) => {
    const parentGuardian = entry.parent_guardian || {
      first_name: entry.parent_guardian_name || '',
      last_name: '',
      email: entry.parent_guardian_email || '',
      cell_phone: entry.parent_guardian_phone || '',
      work_phone: '',
      home_phone: '',
    };
    const emergencyContact = entry.emergency_contact || {
      name: entry.emergency_contact_name || '',
      phone_number: entry.emergency_contact_phone || '',
    };
    setSelectedUser({
      ...defaultEditUserForm,
      ...entry,
      parent_guardian: { ...defaultEditUserForm.parent_guardian, ...parentGuardian },
      emergency_contact: { ...defaultEditUserForm.emergency_contact, ...emergencyContact },
      secondary_contact: { ...defaultEditUserForm.secondary_contact, ...(entry.secondary_contact || {}) },
      role: (entry.role || 'student').toLowerCase(),
      assigned_course_ids: entry.assigned_course_ids || [],
      enrolled_courses: entry.enrolled_courses || [],
    });
    setEditErrors({});
    setEditCourseSearch('');
    setEditCourseSort('az');
  };

  const validateEditUser = (form) => {
    const errors = {};
    const role = (form.role || 'student').toLowerCase();
    if (!String(form.firstname || form.name || '').trim()) errors.name = 'Name is required';
    if (!String(form.email || '').trim()) errors.email = 'Email is required';
    if (role === 'teacher') {
      const rawEmail = String(form.email || '').trim().toLowerCase();
      const normalizedEmail = rawEmail && !rawEmail.includes('@') ? `${rawEmail}@krainitiative.com` : rawEmail;
      if (normalizedEmail && !normalizedEmail.endsWith('@krainitiative.com')) {
        errors.email = 'Teacher email must end with @krainitiative.com';
      }
      if (!(form.assigned_course_ids || []).length) {
        errors.assigned_course_ids = 'Assign at least one course before saving. Teachers must always keep at least one active course.';
      }
    }
    if (role === 'employee') {
      const rawEmail = String(form.email || '').trim().toLowerCase();
      const normalizedEmail = rawEmail && !rawEmail.includes('@') ? `${rawEmail}@krainitiative.com` : rawEmail;
      if (normalizedEmail && !normalizedEmail.endsWith('@krainitiative.com')) {
        errors.email = 'Employee email must end with @krainitiative.com';
      }
    }
    return errors;
  };

  const handleUpdateUser = async () => {
    if (!selectedUser) return;
    const errors = validateEditUser(selectedUser);
    setEditErrors(errors);
    if (Object.keys(errors).length > 0) {
      setFeedback(errors.assigned_course_ids || errors.email || errors.name, true);
      return;
    }
    setSavingUser(true);
    try {
      const role = (selectedUser.role || 'student').toLowerCase();
      const rawEmail = String(selectedUser.email || '').trim().toLowerCase();
      const email = (role === 'teacher' || role === 'employee') && rawEmail && !rawEmail.includes('@')
        ? `${rawEmail}@krainitiative.com`
        : rawEmail;
      const firstname = String(selectedUser.firstname || '').trim();
      const lastname = String(selectedUser.lastname || '').trim();
      const name = String(selectedUser.name || '').trim() || `${firstname} ${lastname}`.trim();

      let payload = {
        name,
        firstname: firstname || null,
        lastname: lastname || null,
        email,
        role,
        bio: selectedUser.bio || '',
        phone_number: selectedUser.phone_number || '',
        accountStatus: selectedUser.accountStatus || 'active',
      };

      if (role === 'student') {
        payload = {
          ...payload,
          date_of_birth: selectedUser.date_of_birth || '',
          address: selectedUser.address || '',
          city: selectedUser.city || '',
          province_state: selectedUser.province_state || '',
          postal_code: selectedUser.postal_code || '',
          country: selectedUser.country || '',
          current_school: selectedUser.current_school || '',
          grade_level: selectedUser.grade_level || '',
          parent_guardian_name: [selectedUser.parent_guardian?.first_name, selectedUser.parent_guardian?.last_name].filter(Boolean).join(' ') || selectedUser.parent_guardian_name || '',
          parent_guardian_email: selectedUser.parent_guardian?.email || selectedUser.parent_guardian_email || '',
          parent_guardian_phone: selectedUser.parent_guardian?.cell_phone || selectedUser.parent_guardian_phone || '',
          parent_guardian: selectedUser.parent_guardian || {},
          emergency_contact_name: selectedUser.emergency_contact?.name || selectedUser.emergency_contact_name || '',
          emergency_contact_relationship: selectedUser.emergency_contact_relationship || '',
          emergency_contact_phone: selectedUser.emergency_contact?.phone_number || selectedUser.emergency_contact_phone || '',
          emergency_contact: selectedUser.emergency_contact || {},
          secondary_contact: selectedUser.secondary_contact || {},
          enrollment_status: selectedUser.enrollment_status || 'active',
          ...(selectedUser.assigned_teacher_id ? { assigned_teacher_id: selectedUser.assigned_teacher_id } : {}),
        };
      } else if (role === 'teacher') {
        payload = {
          ...payload,
          specialization: selectedUser.specialization || '',
          qualifications: selectedUser.qualifications || '',
          employment_status: selectedUser.employment_status || 'full_time',
          teaching_availability: selectedUser.teaching_availability || '',
          assigned_course_ids: (selectedUser.assigned_course_ids || []).filter(Boolean),
        };
      } else if (role === 'employee') {
        payload = {
          ...payload,
          department: selectedUser.department || '',
          position: selectedUser.position || '',
          manager_id: selectedUser.manager_id || null,
          is_manager: Boolean(selectedUser.is_manager),
        };
      }

      await axios.put(`${API}/admin/users/${selectedUser.id}`, payload);
      setFeedback('User updated successfully');
      setSelectedUser(null);
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to update user'), true);
    } finally {
      setSavingUser(false);
    }
  };

  const handleCreateDepartment = async () => {
    if (!deptForm.name.trim()) {
      setFeedback('Department name is required', true);
      return;
    }
    try {
      await axios.post(`${API}/admin/departments`, deptForm);
      setDeptForm({ name: '', description: '' });
      setFeedback('Department created');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to create department'), true);
    }
  };

  const handleAssignEmployeeTask = async () => {
    if (!taskAssignForm.employee_id || !taskAssignForm.title.trim()) {
      setFeedback('Choose an employee and enter a task title', true);
      return;
    }
    try {
      await axios.post(`${API}/admin/employees/tasks`, taskAssignForm);
      setTaskAssignForm({ employee_id: '', title: '', description: '', priority: 'medium', start_date: '', deadline: '', status: 'pending', attachments: [] });
      setFeedback('Task assigned');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to assign task'), true);
    }
  };

  const handleUploadDraftTaskAttachments = async (files) => {
    const selectedFiles = Array.from(files || []).filter(Boolean);
    if (selectedFiles.length === 0) return;
    setTaskAttachmentUploading(true);
    try {
      const uploaded = [];
      for (const file of selectedFiles) {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axios.post(`${API}/admin/employees/tasks/attachments/upload`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (response.data?.attachment) uploaded.push(response.data.attachment);
      }
      setTaskAssignForm((current) => ({
        ...current,
        attachments: [...(current.attachments || []), ...uploaded],
      }));
      setFeedback(`${uploaded.length} attachment${uploaded.length === 1 ? '' : 's'} uploaded`);
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to upload task attachment'), true);
    } finally {
      setTaskAttachmentUploading(false);
    }
  };

  const handleRemoveDraftAttachment = (attachmentId) => {
    setTaskAssignForm((current) => ({
      ...current,
      attachments: (current.attachments || []).filter((item) => item.id !== attachmentId),
    }));
  };

  const handleUploadAttachmentToExistingTask = async (taskId, file) => {
    if (!taskId || !file) return;
    setTaskAttachmentUpdatingId(taskId);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('task_id', taskId);
      await axios.post(`${API}/admin/employees/tasks/attachments/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setFeedback('Attachment added to task');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to add attachment to task'), true);
    } finally {
      setTaskAttachmentUpdatingId('');
    }
  };

  const handleRemoveTaskAttachment = async (taskId, attachmentId) => {
    if (!taskId || !attachmentId) return;
    setTaskAttachmentUpdatingId(taskId);
    try {
      await axios.delete(`${API}/admin/employees/tasks/${taskId}/attachments/${attachmentId}`);
      setFeedback('Attachment removed from task');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to remove attachment'), true);
    } finally {
      setTaskAttachmentUpdatingId('');
    }
  };

  const openTaskEditor = (task) => {
    if (!task?.id) return;
    setTaskEditById((current) => ({
      ...current,
      [task.id]: {
        title: task.title || '',
        description: task.description || '',
        priority: task.priority || 'medium',
        status: task.status || 'pending',
        start_date: task.start_date || '',
        deadline: task.deadline || '',
      },
    }));
  };

  const closeTaskEditor = (taskId) => {
    setTaskEditById((current) => {
      const next = { ...current };
      delete next[taskId];
      return next;
    });
  };

  const handleTaskEditField = (taskId, field, value) => {
    setTaskEditById((current) => ({
      ...current,
      [taskId]: {
        ...(current[taskId] || {}),
        [field]: value,
      },
    }));
  };

  const handleSaveTaskEdit = async (taskId) => {
    const payload = taskEditById[taskId];
    if (!payload) return;
    if (!String(payload.title || '').trim()) {
      setFeedback('Task title is required', true);
      return;
    }
    setSavingTaskEditId(taskId);
    try {
      await axios.patch(`${API}/admin/employees/tasks/${taskId}`, {
        title: String(payload.title || '').trim(),
        description: String(payload.description || '').trim(),
        priority: payload.priority || 'medium',
        status: payload.status || 'pending',
        start_date: payload.start_date || null,
        deadline: payload.deadline || null,
      });
      setFeedback('Task updated successfully');
      closeTaskEditor(taskId);
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to update task'), true);
    } finally {
      setSavingTaskEditId('');
    }
  };

  const handleCreateMeeting = async () => {
    if (!meetingForm.title.trim() || !meetingForm.meeting_at || !meetingForm.platform.trim() || !meetingForm.meeting_url.trim()) {
      setFeedback('Meeting title, date/time, platform, and URL are required', true);
      return;
    }
    if (!meetingForm.send_to_all && (meetingForm.employee_ids || []).length === 0) {
      setFeedback('Choose at least one employee or enable send to all', true);
      return;
    }
    try {
      await axios.post(`${API}/admin/employees/meetings`, meetingForm);
      setMeetingForm(defaultMeetingForm);
      setFeedback('Meeting created and shared with employees');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to create meeting'), true);
    }
  };

  const handleUploadEmployeeMessageAttachments = async (files) => {
    const selectedFiles = Array.from(files || []).filter(Boolean);
    if (selectedFiles.length === 0) return;
    setEmployeeMessageAttachmentUploading(true);
    setEmployeeMessageUploadProgress(0);
    try {
      const formData = new FormData();
      selectedFiles.forEach((file) => formData.append('files', file));
      const response = await axios.post(`${API}/employee/conversations/attachments/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (event) => {
          const total = Number(event.total || 0);
          const loaded = Number(event.loaded || 0);
          if (total > 0) {
            setEmployeeMessageUploadProgress(Math.round((loaded / total) * 100));
          }
        },
      });
      const uploaded = response.data?.attachments || [];
      setEmployeeBroadcastForm((current) => ({
        ...current,
        attachment_ids: [...(current.attachment_ids || []), ...uploaded.map((item) => item.id).filter(Boolean)],
      }));
      setFeedback('File uploaded successfully.');
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Upload failed. Please try again.'), true);
    } finally {
      setEmployeeMessageAttachmentUploading(false);
      setEmployeeMessageUploadProgress(0);
    }
  };

  const handleUploadConversationStartAttachments = async (files) => {
    const selectedFiles = Array.from(files || []).filter(Boolean);
    if (selectedFiles.length === 0) return;
    setConversationStartAttachmentUploading(true);
    try {
      const formData = new FormData();
      selectedFiles.forEach((file) => formData.append('files', file));
      const response = await axios.post(`${API}/employee/conversations/attachments/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setConversationStartAttachmentDraft((current) => [...current, ...(response.data?.attachments || [])]);
      setFeedback('Attachment added to draft.');
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to upload draft attachment'), true);
    } finally {
      setConversationStartAttachmentUploading(false);
    }
  };

  const handleStartDirectConversation = async () => {
    if (!conversationRecipientId) {
      setFeedback('Select a recipient first', true);
      return;
    }
    const subject = String(conversationSubjectDraft || '').trim();
    const initialMessage = String(conversationStartDraft || '').trim();
    const attachmentIds = (conversationStartAttachmentDraft || []).map((item) => item.id).filter(Boolean);
    if (!subject) {
      setFeedback('Add a subject before sending the direct conversation', true);
      return;
    }
    if (!initialMessage && attachmentIds.length === 0) {
      setFeedback('Write a message or attach at least one file', true);
      return;
    }
    try {
      const response = await axios.post(`${API}/employee/conversations`, {
        participant_ids: [conversationRecipientId],
        subject,
        initial_message: initialMessage,
        attachment_ids: attachmentIds,
      });
      const conversationId = response.data?.conversation?.id;
      setConversationSubjectDraft('');
      setConversationStartDraft('');
      setConversationStartAttachmentDraft([]);
      await refreshPortal();
      if (conversationId) {
        await handleOpenEmployeeConversation(conversationId);
      }
      setFeedback('Conversation message sent successfully');
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to start conversation'), true);
    }
  };

  const handleSendEmployeeMessage = async () => {
    if (!employeeBroadcastForm.title.trim() || !employeeBroadcastForm.message.trim()) {
      setFeedback('Message title and content are required', true);
      return;
    }
    if (!employeeBroadcastForm.send_to_all_employees && (employeeBroadcastForm.employee_ids || []).length === 0) {
      setFeedback('Select one or more employees or enable broadcast to all employees', true);
      return;
    }
    try {
      await axios.post(`${API}/admin/employees/conversations/broadcast`, employeeBroadcastForm);
      setEmployeeBroadcastForm({
        title: '',
        message: '',
        employee_ids: [],
        send_to_all_employees: false,
        attachment_ids: [],
      });
      setFeedback('Message sent successfully');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to send employee message'), true);
    }
  };

  const handleOpenEmployeeConversation = async (conversationId) => {
    if (!conversationId) return;
    setSelectedEmployeeConversationId(conversationId);
    try {
      const response = await axios.get(`${API}/employee/conversations/${conversationId}`);
      setEmployeeConversationDetail(response.data?.conversation || null);
      setEmployeeConversationMessages(response.data?.messages || []);
      await axios.post(`${API}/employee/conversations/${conversationId}/read`);
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to open conversation'), true);
    }
  };

  const handleUploadConversationReplyAttachments = async (files) => {
    const list = Array.from(files || []).filter(Boolean);
    if (!list.length || !selectedEmployeeConversationId) return;
    setConversationReplyAttachmentUploading(true);
    try {
      const formData = new FormData();
      list.forEach((f) => formData.append('files', f));
      formData.append('conversation_id', selectedEmployeeConversationId);
      const res = await axios.post(`${API}/employee/conversations/attachments/upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      setConversationReplyAttachmentDraft((cur) => [...cur, ...(res.data?.attachments || [])]);
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to upload file'), true);
    } finally {
      setConversationReplyAttachmentUploading(false);
    }
  };

  const handleReplyEmployeeMessage = async () => {
    if (!selectedEmployeeConversationId) {
      setFeedback('Select a conversation first', true);
      return;
    }
    const reply = String(employeeConversationReply || '').trim();
    const attachmentIds = conversationReplyAttachmentDraft.map((a) => a.id).filter(Boolean);
    if (!reply && attachmentIds.length === 0) {
      setFeedback('Write a message or attach a file', true);
      return;
    }
    try {
      await axios.post(`${API}/employee/conversations/${selectedEmployeeConversationId}/messages`, { message: reply, attachment_ids: attachmentIds });
      setEmployeeConversationReply('');
      setConversationReplyAttachmentDraft([]);
      setFeedback('Reply sent successfully');
      await Promise.all([handleOpenEmployeeConversation(selectedEmployeeConversationId), refreshPortal()]);
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to send reply'), true);
    }
  };

  const handleSaveMsgEdit = async () => {
    if (!editingMsgId || !selectedEmployeeConversationId) return;
    const text = editingMsgText.trim();
    if (!text) { setFeedback('Message cannot be empty', true); return; }
    try {
      await axios.patch(`${API}/employee/conversations/${selectedEmployeeConversationId}/messages/${editingMsgId}`, { message: text });
      setEditingMsgId('');
      setEditingMsgText('');
      setFeedback('Message updated');
      await handleOpenEmployeeConversation(selectedEmployeeConversationId);
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to edit message'), true);
    }
  };

  const handleSetEmployeeMessageStatus = async (conversationId, pinned) => {
    try {
      await axios.patch(`${API}/admin/employees/conversations/${conversationId}/pin`, { pinned });
      setFeedback('Conversation updated successfully');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to update conversation'), true);
    }
  };

  const handleDeleteEmployeeConversation = async (conversationId) => {
    if (!conversationId) return;
    if (!window.confirm('Delete this conversation?')) return;
    try {
      await axios.delete(`${API}/admin/employees/conversations/${conversationId}`, { data: { reason: 'Removed by admin' } });
      setFeedback('Conversation deleted successfully');
      if (selectedEmployeeConversationId === conversationId) {
        setSelectedEmployeeConversationId('');
        setEmployeeConversationDetail(null);
        setEmployeeConversationMessages([]);
      }
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to delete conversation'), true);
    }
  };

  const handleUserPhotoUpload = async (file) => {
    if (!selectedUser?.id || !file) return;
    setPhotoUploading(true);
    try {
      const formData = new FormData();
      formData.append('profile_picture', file);
      const response = await axios.post(`${API}/admin/users/${selectedUser.id}/photo`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setSelectedUser((prev) => (prev ? { ...prev, profile_photo_url: response.data?.profile_photo_url } : prev));
      setFeedback('Profile photo updated');
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to upload photo'), true);
    } finally {
      setPhotoUploading(false);
    }
  };

  const toggleUserSuspension = async (entry) => {
    try {
      await axios.post(`${API}/admin/users/${entry.id}/suspend`, null, { params: { suspended: entry.is_active } });
      setFeedback(entry.is_active ? 'User suspended' : 'User reactivated');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to update user status'), true);
    }
  };

  const resetPassword = async (entry) => {
    const customPassword = window.prompt(`Enter a new temporary password for ${entry.email} or leave blank to auto-generate`, '');
    try {
      const response = await axios.post(`${API}/admin/users/${entry.id}/reset-password`, { new_password: customPassword || undefined });
      setFeedback(`Password reset. Temporary password: ${response.data?.temporary_password || 'generated'}`);
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to reset password'), true);
    }
  };

  const deleteUser = async (entry) => {
    if (!window.confirm(`Delete ${entry.email}?`)) return;
    try {
      await axios.delete(`${API}/admin/users/${entry.id}`);
      setFeedback('User deleted');
      if (selectedUser?.id === entry.id) setSelectedUser(null);
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to delete user'), true);
    }
  };

  const handleSaveCourse = async () => {
    if (!String(courseForm.subject || '').trim()) {
      setFeedback('Subject is required', true);
      return;
    }
    if (!String(courseForm.category || '').trim()) {
      setFeedback('Category is required', true);
      return;
    }
    if (!String(courseForm.title || '').trim()) {
      setFeedback('Course title is required', true);
      return;
    }
    const normalizedTeacherIds = Array.from(new Set((courseForm.teacher_ids || []).filter(Boolean)));
    const fallbackTeacherId = courseForm.teacher_id || normalizedTeacherIds[0] || '';
    const payload = {
      ...courseForm,
      catalog_group: String(courseForm.catalog_group || 'Robotics').trim(),
      teacher_id: fallbackTeacherId || undefined,
      teacher_ids: normalizedTeacherIds,
      subject: String(courseForm.subject || '').trim(),
      category: courseForm.category || 'Beginner',
      level: courseForm.level || courseForm.difficulty_level || 'Beginner',
      difficulty_level: courseForm.difficulty_level || courseForm.level || 'Beginner',
      best_for: String(courseForm.best_for || '').trim(),
      price: Number(courseForm.price || 0),
      estimated_hours: Number(courseForm.estimated_hours || 0),
      learning_objectives: splitLines(courseForm.learning_objectives),
      prerequisites: splitLines(courseForm.prerequisites),
      learning_outcomes: splitLines(courseForm.learning_outcomes),
      projects: splitLines(courseForm.projects),
      career_paths: splitLines(courseForm.career_paths),
    };
    try {
      if (selectedCourse?.id) {
        await axios.put(`${API}/admin/courses/${selectedCourse.id}`, payload);
        setFeedback('Course updated');
      } else {
        await axios.post(`${API}/admin/courses`, payload);
        setFeedback('Course created');
      }
      setSelectedCourse(null);
      setCourseForm(defaultCourseForm);
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to save course'), true);
    }
  };

  const setCourseStatus = async (courseId, status, availabilityStatus = status) => {
    try {
      await axios.post(`${API}/admin/courses/${courseId}/status`, { status, availability_status: availabilityStatus });
      setFeedback('Course status updated');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to update course status'), true);
    }
  };

  const deleteCourse = async (courseId) => {
    if (!window.confirm('Delete this course?')) return;
    try {
      await axios.delete(`${API}/admin/courses/${courseId}`);
      setFeedback('Course deleted');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to delete course'), true);
    }
  };

  const handleSaveJob = async () => {
    const payload = {
      ...jobForm,
      responsibilities: jobForm.responsibilities.split('\n').map((item) => item.trim()).filter(Boolean),
      qualifications: jobForm.qualifications.split('\n').map((item) => item.trim()).filter(Boolean),
      preferred_qualifications: jobForm.preferred_qualifications.split('\n').map((item) => item.trim()).filter(Boolean),
      benefits: jobForm.benefits.split('\n').map((item) => item.trim()).filter(Boolean),
      application_requirements: jobForm.application_requirements.split('\n').map((item) => item.trim()).filter(Boolean),
      application_deadline: jobForm.application_deadline || null,
    };
    try {
      if (selectedJob?.id) {
        await axios.put(`${API}/admin/jobs/${selectedJob.id}`, payload);
        setFeedback('Job updated');
      } else {
        await axios.post(`${API}/admin/jobs`, payload);
        setFeedback('Job created');
      }
      setSelectedJob(null);
      setJobForm(defaultJobForm);
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to save job'), true);
    }
  };

  const toggleJobStatus = async (jobId, status) => {
    try {
      await axios.post(`${API}/admin/jobs/${jobId}/status`, { status });
      setFeedback(`Job marked ${status}`);
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to update job status'), true);
    }
  };

  const deleteJob = async (jobId) => {
    if (!window.confirm('Delete this job posting?')) return;
    try {
      await axios.delete(`${API}/admin/jobs/${jobId}`);
      setFeedback('Job deleted');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to delete job'), true);
    }
  };

  const updateApplicationStatus = async (applicationId, status) => {
    try {
      await axios.post(`${API}/admin/job-applications/${applicationId}/status`, { status });
      setFeedback('Application status updated');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to update application status'), true);
    }
  };

  const resendConfirmationEmail = async (applicationId) => {
    try {
      const response = await axios.post(`${API}/admin/job-applications/${applicationId}/resend-confirmation-email`);
      setFeedback(response.data?.message || 'Confirmation email resent');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to resend confirmation email'), true);
    }
  };

  const startNewHackathon = () => {
    setEditingHackathonId('');
    setHackathonForm(defaultHackathonForm);
  };

  const editHackathon = (hackathon) => {
    setSelectedHackathonId(hackathon.id || '');
    setEditingHackathonId(hackathon.id || '');
  };

  const handleSaveHackathon = async () => {
    if (!hackathonForm.title.trim() || !hackathonForm.description.trim() || !hackathonForm.application_deadline) {
      setFeedback('Title, description, and application deadline are required', true);
      return;
    }

    const payload = {
      ...hackathonForm,
      event_date: hackathonForm.event_date ? new Date(hackathonForm.event_date).toISOString() : null,
      application_deadline: new Date(hackathonForm.application_deadline).toISOString(),
      application_instructions: splitLines(hackathonForm.application_instructions),
    };

    try {
      if (editingHackathonId) {
        await axios.put(`${API}/admin/hackathons/${editingHackathonId}`, payload);
        setFeedback('Hackathon updated');
      } else {
        await axios.post(`${API}/admin/hackathons`, payload);
        setFeedback('Hackathon created');
      }
      startNewHackathon();
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to save hackathon'), true);
    }
  };

  const runHackathonAction = async (action, hackathonId) => {
    try {
      if (action === 'delete') {
        if (!window.confirm('Delete this hackathon?')) return;
        await axios.delete(`${API}/admin/hackathons/${hackathonId}`);
        setFeedback('Hackathon deleted');
      }
      if (action === 'publish') {
        await axios.post(`${API}/admin/hackathons/${hackathonId}/publish`);
        setFeedback('Hackathon published');
      }
      if (action === 'close') {
        await axios.post(`${API}/admin/hackathons/${hackathonId}/close-registration`);
        setFeedback('Applications closed');
      }
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to update hackathon'), true);
    }
  };

  const uploadHackathonImage = async (file) => {
    if (!file) return;
    if (!editingHackathonId) {
      setFeedback('Create the hackathon first, then upload its image', true);
      return;
    }
    try {
      setHackathonImageUploading(true);
      const formData = new FormData();
      formData.append('image', file);
      const response = await axios.post(`${API}/admin/hackathons/${editingHackathonId}/image`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setHackathonForm((current) => ({ ...current, image_url: response.data?.image_url || '' }));
      setFeedback('Hackathon image uploaded');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to upload hackathon image'), true);
    } finally {
      setHackathonImageUploading(false);
    }
  };

  const openHackathonApplication = async (applicationId) => {
    if (!selectedHackathonId || !applicationId) return;
    try {
      const response = await axios.get(`${API}/admin/hackathons/${selectedHackathonId}/applications/${applicationId}`);
      setSelectedHackathonApplication(response.data?.application || null);
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to load application details'), true);
    }
  };

  const updateHackathonApplicationStatus = async (applicationId, status) => {
    if (!selectedHackathonId || !applicationId) return;
    try {
      await axios.post(`${API}/admin/hackathons/${selectedHackathonId}/applications/${applicationId}/status`, { status });
      setFeedback('Application status updated');
      const response = await axios.get(`${API}/admin/hackathons/${selectedHackathonId}/applications`, {
        params: {
          search: hackathonSearch.trim() || undefined,
          status: hackathonStatusFilter || undefined,
        },
      });
      setHackathonApplications(response.data?.applications || []);
      setHackathonApplicationStats(response.data?.stats || hackathonApplicationStats);
      await openHackathonApplication(applicationId);
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to update application status'), true);
    }
  };

  const toggleHackathonApplicationSelection = (applicationId) => {
    setSelectedHackathonApplicationIds((current) => (
      current.includes(applicationId)
        ? current.filter((item) => item !== applicationId)
        : [...current, applicationId]
    ));
  };

  const sendHackathonEmails = async (sendAll = false) => {
    if (!selectedHackathonId) {
      setFeedback('Select a hackathon first', true);
      return;
    }
    if (!hackathonEmailForm.subject.trim() || !hackathonEmailForm.message.trim()) {
      setFeedback('Email subject and message are required', true);
      return;
    }
    if (!sendAll && selectedHackathonApplicationIds.length === 0) {
      setFeedback('Select at least one application', true);
      return;
    }
    if (sendAll && !window.confirm('Send this email to all currently filtered applicants?')) {
      return;
    }
    try {
      const response = await axios.post(`${API}/admin/hackathons/${selectedHackathonId}/applications/email`, {
        application_ids: sendAll ? [] : selectedHackathonApplicationIds,
        subject: hackathonEmailForm.subject,
        message: hackathonEmailForm.message,
        send_all: sendAll,
        confirm_send_all: sendAll,
        status_filter: sendAll ? (hackathonStatusFilter || null) : null,
        search: sendAll ? (hackathonSearch.trim() || null) : null,
      });
      setFeedback(response.data?.message || 'Email sent');
      if (!sendAll) {
        setSelectedHackathonApplicationIds([]);
      }
      if (selectedHackathonApplication?.id) {
        await openHackathonApplication(selectedHackathonApplication.id);
      }
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to send email'), true);
    }
  };

  const handleSaveClass = async () => {
    const payload = { ...classForm };
    try {
      if (selectedClass?.id) {
        await axios.put(`${API}/admin/classes/${selectedClass.id}`, payload);
        setFeedback('Class updated');
      } else {
        await axios.post(`${API}/admin/classes`, payload);
        setFeedback('Class created');
      }
      setSelectedClass(null);
      setClassForm(defaultClassForm);
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to save class'), true);
    }
  };

  const cancelClass = async (classId) => {
    try {
      await axios.post(`${API}/admin/classes/${classId}/cancel`);
      setFeedback('Class cancelled');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to cancel class'), true);
    }
  };

  const deleteClass = async (classId) => {
    if (!window.confirm('Delete this class?')) return;
    try {
      await axios.delete(`${API}/admin/classes/${classId}`);
      setFeedback('Class deleted');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to delete class'), true);
    }
  };

  const processEnrollment = async (requestId, action, entry) => {
    const teacherId = window.prompt('Optional teacher id override', entry.teacher_id || '') || undefined;
    const classId = window.prompt('Optional class id assignment', entry.class_id || '') || undefined;
    const reason = action === 'approve' ? undefined : (window.prompt('Optional note / reason', '') || undefined);
    try {
      await axios.post(`${API}/admin/enrollments/${requestId}/${action}`, { teacher_id: teacherId, class_id: classId, reason });
      setFeedback(`Enrollment ${action}d`);
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, `Unable to ${action} enrollment`), true);
    }
  };

  const toggleMessageChannel = (channel) => {
    setMessageForm((current) => ({
      ...current,
      channels: current.channels.includes(channel)
        ? current.channels.filter((item) => item !== channel)
        : [...current.channels, channel],
    }));
  };

  const saveMessage = async () => {
    try {
      await axios.post(`${API}/admin/messages`, messageForm);
      setMessageForm(defaultMessageForm);
      setFeedback('Message sent');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to send message'), true);
    }
  };

  const saveNewsletter = async () => {
    try {
      await axios.post(`${API}/admin/newsletters`, {
        ...newsletterForm,
        scheduled_for: newsletterForm.scheduled_for || undefined,
      });
      setNewsletterForm(defaultNewsletterForm);
      setFeedback('Newsletter saved');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to save newsletter'), true);
    }
  };

  const saveAnnouncement = async () => {
    try {
      await axios.post(`${API}/admin/announcements`, announcementForm);
      setAnnouncementForm(defaultAnnouncementForm);
      setFeedback('Announcement created');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to create announcement'), true);
    }
  };

  const saveContentSection = async (section) => {
    try {
      await axios.put(`${API}/admin/content/${section}`, contentDrafts[section] || { title: '', body: '' });
      setFeedback(`${section} content updated`);
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to update content'), true);
    }
  };

  const saveSettings = async () => {
    try {
      await axios.put(`${API}/admin/settings`, settings);
      setFeedback('Settings updated');
      await refreshPortal();
    } catch (requestError) {
      setFeedback(getErrorMessage(requestError, 'Unable to save settings'), true);
    }
  };

  if (!isAdmin) {
    return (
      <div className="bg-black min-h-screen text-white flex items-center justify-center px-6">
        <div className="max-w-xl bg-gray-900 border border-red-500/40 rounded-2xl p-8 text-center">
          <h1 className="text-3xl font-bold text-red-400 mb-3">Admin Access Required</h1>
          <p className="text-gray-300">Only administrator accounts can open the K.R.A Administration Portal.</p>
          <button onClick={() => onPageChange('home')} className="mt-6 bg-yellow-500 hover:bg-yellow-600 text-black px-5 py-3 rounded-lg font-bold">Return Home</button>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="bg-black min-h-screen text-white flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-yellow-400"></div>
      </div>
    );
  }

  return (
    <div className="bg-black min-h-screen text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div>
            <div className="text-sm text-gray-400">Protected Administrator Portal</div>
            <h1 className="text-4xl font-bold text-yellow-400">K.R.A Administration Dashboard</h1>
            <p className="text-gray-300 mt-2">Manage users, courses, classes, enrollments, communications, content, settings, certificates, finance, attendance, and audit trails from one place.</p>
          </div>
          <div className="flex gap-3 flex-wrap">
            <button onClick={() => onPageChange('admin-verifications')} className="border border-yellow-400 text-yellow-400 px-4 py-2 rounded-lg hover:bg-yellow-400 hover:text-black">Verification Queue</button>
            <button onClick={() => onPageChange('admin-certificates')} className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 py-2 rounded-lg font-bold">Certificates</button>
          </div>
        </div>

        {(status || error) && (
          <div className={`rounded-xl px-4 py-3 border ${error ? 'bg-red-900/30 border-red-500/40 text-red-200' : 'bg-green-900/30 border-green-500/40 text-green-200'}`}>
            {error || status}
          </div>
        )}

        <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-3">
          {tabs.map((tab) => (
            <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-4 py-3 rounded-xl border text-sm font-medium transition-all ${activeTab === tab.id ? 'border-yellow-400 bg-yellow-400/10 text-yellow-300' : 'border-gray-700 bg-gray-900 text-gray-300 hover:border-yellow-400/40'}`}>
              {tab.label}
            </button>
          ))}
        </div>

        {activeTab === 'overview' && (
          <section className="space-y-6">
            <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-4">
              {[
                ['Students', dashboard?.overview?.total_students],
                ['Teachers', dashboard?.overview?.total_teachers],
                ['Courses', dashboard?.overview?.total_courses],
                ['Classes', dashboard?.overview?.total_classes],
                ['Enrollments', dashboard?.overview?.total_enrollments],
                ['Certificates', dashboard?.overview?.total_certificates_issued],
              ].map(([label, value]) => (
                <div key={label} className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-5">
                  <div className="text-sm text-gray-400">{label}</div>
                  <div className="text-3xl font-bold text-yellow-400 mt-2">{value || 0}</div>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6">
                <h2 className="text-xl font-bold text-yellow-400 mb-4">Attendance & Revenue</h2>
                <div className="space-y-2 text-gray-300">
                  <div>Attendance Rate: <span className="text-white">{dashboard?.overview?.attendance_rate || 0}%</span></div>
                  <div>Total Revenue: <span className="text-white">${Number(dashboard?.overview?.revenue_total || 0).toFixed(2)}</span></div>
                  <div>Pending Requests: <span className="text-white">{dashboard?.overview?.pending_requests || 0}</span></div>
                </div>
              </div>
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 lg:col-span-2">
                <h2 className="text-xl font-bold text-yellow-400 mb-4">System Notifications</h2>
                <div className="space-y-3 max-h-72 overflow-y-auto pr-1">
                  {(dashboard?.notifications || []).map((item) => (
                    <div key={item.id} className="bg-gray-800 rounded-xl p-4">
                      <div className="font-semibold text-white">{item.title || 'Notification'}</div>
                      <div className="text-gray-300 text-sm">{item.message}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        )}

        {activeTab === 'users' && (
          <section className="grid grid-cols-1 xl:grid-cols-3 gap-6">
            <div className="xl:col-span-2 bg-gray-900 border border-yellow-400/20 rounded-2xl p-6">
              <div className="flex flex-col md:flex-row gap-3 mb-4">
                <input value={userSearch} onChange={(e) => setUserSearch(e.target.value)} className="flex-1 bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Search users" />
                <select value={userRoleFilter} onChange={(e) => setUserRoleFilter(e.target.value)} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                  <option value="">All roles</option>
                  <option value="student">Students</option>
                  <option value="teacher">Teachers</option>
                  <option value="employee">Employees</option>
                  <option value="admin">Admins</option>
                </select>
              </div>
              <div className="space-y-3 max-h-[720px] overflow-y-auto pr-1">
                {users.map((entry) => (
                  <div key={entry.id} className="bg-gray-800 rounded-xl p-4">
                    <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                      <div>
                        <div className="text-white font-semibold">{entry.name}</div>
                        <div className="text-gray-400 text-sm">{entry.email} • {entry.role}</div>
                        <div className="text-gray-500 text-xs mt-1">Enrollments: {entry.enrolled_count || 0} • Active: {entry.is_active ? 'Yes' : 'No'}</div>
                      </div>
                      <div className="flex gap-2 flex-wrap">
                        <button onClick={() => openEditUser(entry)} className="border border-yellow-400 text-yellow-400 px-3 py-2 rounded-lg text-sm">Edit</button>
                        <button onClick={() => toggleUserSuspension(entry)} className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-lg text-sm">{entry.is_active ? 'Suspend' : 'Reactivate'}</button>
                        <button onClick={() => resetPassword(entry)} className="bg-yellow-500 hover:bg-yellow-600 text-black px-3 py-2 rounded-lg text-sm font-bold">Reset Password</button>
                        <button onClick={() => deleteUser(entry)} className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg text-sm">Delete</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="space-y-6">
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6">
                <h2 className="text-xl font-bold text-yellow-400 mb-2">Teacher Management</h2>
                <p className="text-sm text-gray-400 mb-4">Use this section to create and manage teacher accounts. Teacher emails must end with @krainitiative.com.</p>
                <div className="space-y-3">
                  <input value={userForm.name} onChange={(e) => setUserForm({ ...userForm, name: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Full name" />
                  <div className="grid grid-cols-2 gap-3">
                    <input value={userForm.firstname} onChange={(e) => setUserForm({ ...userForm, firstname: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="First name" />
                    <input value={userForm.lastname} onChange={(e) => setUserForm({ ...userForm, lastname: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Last name" />
                  </div>
                  <input value={userForm.email} onChange={(e) => setUserForm({ ...userForm, email: e.target.value })} type="email" className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Email" />
                  <input value={userForm.password} onChange={(e) => setUserForm({ ...userForm, password: e.target.value })} type="password" className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Password" />
                  <select value={userForm.role} onChange={(e) => setUserForm({ ...userForm, role: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                    <option value="student">Student</option>
                    <option value="teacher">Teacher</option>
                    <option value="employee">Employee</option>
                    <option value="admin">Admin</option>
                  </select>
                  {userForm.role === 'teacher' && (
                    <AssignedCoursesPicker
                      courses={courses}
                      selectedIds={userForm.assigned_course_ids}
                      onChange={(nextIds) => setUserForm({ ...userForm, assigned_course_ids: nextIds })}
                      searchValue={teacherCourseSearch}
                      onSearchChange={setTeacherCourseSearch}
                      sortOrder={teacherCourseSort}
                      onSortChange={setTeacherCourseSort}
                    />
                  )}
                  {userForm.role === 'employee' && (
                    <div className="space-y-3 border border-yellow-400/20 rounded-lg p-3">
                      <input value={userForm.department || ''} onChange={(e) => setUserForm({ ...userForm, department: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Department" />
                      <input value={userForm.position || ''} onChange={(e) => setUserForm({ ...userForm, position: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Position / Job Title" />
                      <select value={userForm.manager_id || ''} onChange={(e) => setUserForm({ ...userForm, manager_id: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                        <option value="">No manager</option>
                        {users.filter((u) => ['employee', 'admin'].includes((u.role || '').toLowerCase())).map((u) => (
                          <option key={u.id} value={u.id}>{u.name || u.email}</option>
                        ))}
                      </select>
                      <label className="flex items-center gap-2 text-sm text-gray-300">
                        <input type="checkbox" checked={Boolean(userForm.is_manager)} onChange={(e) => setUserForm({ ...userForm, is_manager: e.target.checked })} />
                        Grant manager access (can assign tasks to other employees)
                      </label>
                    </div>
                  )}
                  <textarea value={userForm.bio} onChange={(e) => setUserForm({ ...userForm, bio: e.target.value })} rows={3} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Bio" />
                  <button onClick={handleCreateUser} className="w-full bg-yellow-500 hover:bg-yellow-600 text-black py-3 rounded-lg font-bold">Create Teacher / User</button>
                </div>
              </div>
              {selectedUser && (
                <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 max-h-[860px] overflow-y-auto pr-1">
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-xl font-bold text-yellow-400">
                      Edit {selectedUser.role === 'teacher' ? 'Teacher' : selectedUser.role === 'admin' ? 'Admin' : selectedUser.role === 'employee' ? 'Employee' : 'Student'}
                    </h2>
                    <span className="text-xs text-gray-500">ID: {selectedUser.id}</span>
                  </div>

                  <div className="space-y-5">
                    {/* Role */}
                    <LabeledSelect
                      label="Role"
                      value={selectedUser.role}
                      onChange={(v) => setSelectedUser({ ...selectedUser, role: v })}
                      options={[
                        { value: 'student', label: 'Student' },
                        { value: 'teacher', label: 'Teacher' },
                        { value: 'employee', label: 'Employee' },
                        { value: 'admin', label: 'Admin' },
                      ]}
                    />

                    {/* Profile Photo */}
                    <div className="flex items-center gap-4">
                      {selectedUser.profile_photo_url ? (
                        <img src={selectedUser.profile_photo_url} alt="Profile" className="w-16 h-16 rounded-full object-cover border border-gray-600" />
                      ) : (
                        <div className="w-16 h-16 rounded-full bg-gray-700 flex items-center justify-center text-gray-400 text-xs">No Photo</div>
                      )}
                      <div>
                        <label className="inline-block bg-gray-800 hover:bg-gray-700 border border-gray-600 text-gray-200 px-3 py-2 rounded-lg text-sm cursor-pointer">
                          {photoUploading ? 'Uploading...' : 'Upload Photo'}
                          <input
                            type="file"
                            accept="image/*"
                            className="hidden"
                            disabled={photoUploading}
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (file) handleUserPhotoUpload(file);
                              e.target.value = '';
                            }}
                          />
                        </label>
                      </div>
                    </div>

                    {/* Personal Info */}
                    <div className="space-y-3">
                      <h3 className="text-sm font-bold text-yellow-400 uppercase tracking-wide">Personal Information</h3>
                      <div className="grid grid-cols-2 gap-3">
                        <LabeledInput label="First Name" value={selectedUser.firstname} onChange={(v) => setSelectedUser({ ...selectedUser, firstname: v })} error={editErrors.name} />
                        <LabeledInput label="Last Name" value={selectedUser.lastname} onChange={(v) => setSelectedUser({ ...selectedUser, lastname: v })} />
                      </div>
                      <LabeledInput label="Email" type="email" value={selectedUser.email} onChange={(v) => setSelectedUser({ ...selectedUser, email: v })} error={editErrors.email} />
                      <LabeledInput label="Phone Number" value={selectedUser.phone_number} onChange={(v) => setSelectedUser({ ...selectedUser, phone_number: v })} />

                      {selectedUser.role === 'student' && (
                        <>
                          <div className="grid grid-cols-2 gap-3">
                            <LabeledInput label="Date of Birth" type="date" value={selectedUser.date_of_birth} onChange={(v) => setSelectedUser({ ...selectedUser, date_of_birth: v })} />
                            <LabeledInput label="Country" value={selectedUser.country} onChange={(v) => setSelectedUser({ ...selectedUser, country: v })} />
                          </div>
                          <LabeledInput label="Address" value={selectedUser.address} onChange={(v) => setSelectedUser({ ...selectedUser, address: v })} />
                          <div className="grid grid-cols-3 gap-3">
                            <LabeledInput label="City" value={selectedUser.city} onChange={(v) => setSelectedUser({ ...selectedUser, city: v })} />
                            <LabeledInput label="Province / State" value={selectedUser.province_state} onChange={(v) => setSelectedUser({ ...selectedUser, province_state: v })} />
                            <LabeledInput label="Postal Code" value={selectedUser.postal_code} onChange={(v) => setSelectedUser({ ...selectedUser, postal_code: v })} />
                          </div>
                        </>
                      )}

                      {selectedUser.role === 'teacher' && (
                        <>
                          <LabeledInput label="Specialization" value={selectedUser.specialization} onChange={(v) => setSelectedUser({ ...selectedUser, specialization: v })} placeholder="e.g. Robotics, Mathematics" />
                          <LabeledInput label="Qualifications" textarea rows={2} value={selectedUser.qualifications} onChange={(v) => setSelectedUser({ ...selectedUser, qualifications: v })} />
                        </>
                      )}

                      {selectedUser.role === 'employee' && (
                        <>
                          <div className="grid grid-cols-2 gap-3">
                            <LabeledInput label="Department" value={selectedUser.department} onChange={(v) => setSelectedUser({ ...selectedUser, department: v })} />
                            <LabeledInput label="Position" value={selectedUser.position} onChange={(v) => setSelectedUser({ ...selectedUser, position: v })} />
                          </div>
                          <LabeledSelect
                            label="Manager"
                            value={selectedUser.manager_id || ''}
                            onChange={(v) => setSelectedUser({ ...selectedUser, manager_id: v })}
                            options={[
                              { value: '', label: 'No manager' },
                              ...users.filter((u) => ['employee', 'admin'].includes((u.role || '').toLowerCase()) && u.id !== selectedUser.id).map((u) => ({ value: u.id, label: u.name || u.email })),
                            ]}
                          />
                          <LabeledSelect
                            label="Account Status"
                            value={selectedUser.accountStatus}
                            onChange={(v) => setSelectedUser({ ...selectedUser, accountStatus: v })}
                            options={[
                              { value: 'active', label: 'Active' },
                              { value: 'suspended', label: 'Suspended' },
                              { value: 'inactive', label: 'Inactive' },
                            ]}
                          />
                          <label className="flex items-center gap-2 text-sm text-gray-300">
                            <input type="checkbox" checked={Boolean(selectedUser.is_manager)} onChange={(e) => setSelectedUser({ ...selectedUser, is_manager: e.target.checked })} />
                            Grant manager access (can assign tasks to other employees)
                          </label>
                        </>
                      )}

                      <LabeledInput label="Biography" textarea rows={3} value={selectedUser.bio} onChange={(v) => setSelectedUser({ ...selectedUser, bio: v })} />
                    </div>

                    {/* Student: Educational Info */}
                    {selectedUser.role === 'student' && (
                      <div className="space-y-3">
                        <h3 className="text-sm font-bold text-yellow-400 uppercase tracking-wide">Educational Information</h3>
                        <div className="grid grid-cols-2 gap-3">
                          <LabeledInput label="Current School" value={selectedUser.current_school} onChange={(v) => setSelectedUser({ ...selectedUser, current_school: v })} />
                          <LabeledInput label="Grade Level" value={selectedUser.grade_level} onChange={(v) => setSelectedUser({ ...selectedUser, grade_level: v })} />
                        </div>
                        <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wide">Parent / Guardian Information</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                          <LabeledInput label="First Name" value={selectedUser.parent_guardian?.first_name || ''} onChange={(v) => setSelectedUser({ ...selectedUser, parent_guardian: { ...selectedUser.parent_guardian, first_name: v } })} />
                          <LabeledInput label="Last Name" value={selectedUser.parent_guardian?.last_name || ''} onChange={(v) => setSelectedUser({ ...selectedUser, parent_guardian: { ...selectedUser.parent_guardian, last_name: v } })} />
                          <LabeledInput label="Email" type="email" value={selectedUser.parent_guardian?.email || ''} onChange={(v) => setSelectedUser({ ...selectedUser, parent_guardian: { ...selectedUser.parent_guardian, email: v } })} />
                          <LabeledInput label="Cell Phone" value={selectedUser.parent_guardian?.cell_phone || ''} onChange={(v) => setSelectedUser({ ...selectedUser, parent_guardian: { ...selectedUser.parent_guardian, cell_phone: v } })} />
                          <LabeledInput label="Work Phone" value={selectedUser.parent_guardian?.work_phone || ''} onChange={(v) => setSelectedUser({ ...selectedUser, parent_guardian: { ...selectedUser.parent_guardian, work_phone: v } })} />
                          <LabeledInput label="Home Phone" value={selectedUser.parent_guardian?.home_phone || ''} onChange={(v) => setSelectedUser({ ...selectedUser, parent_guardian: { ...selectedUser.parent_guardian, home_phone: v } })} />
                        </div>
                        <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wide">Emergency Contact</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                          <LabeledInput label="Name" value={selectedUser.emergency_contact?.name || ''} onChange={(v) => setSelectedUser({ ...selectedUser, emergency_contact: { ...selectedUser.emergency_contact, name: v } })} />
                          <LabeledInput label="Phone" value={selectedUser.emergency_contact?.phone_number || ''} onChange={(v) => setSelectedUser({ ...selectedUser, emergency_contact: { ...selectedUser.emergency_contact, phone_number: v } })} />
                        </div>
                        <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wide">Secondary Contact (Optional)</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                          <LabeledInput label="Name" value={selectedUser.secondary_contact?.name || ''} onChange={(v) => setSelectedUser({ ...selectedUser, secondary_contact: { ...selectedUser.secondary_contact, name: v } })} />
                          <LabeledInput label="Phone" value={selectedUser.secondary_contact?.phone_number || ''} onChange={(v) => setSelectedUser({ ...selectedUser, secondary_contact: { ...selectedUser.secondary_contact, phone_number: v } })} />
                        </div>
                      </div>
                    )}

                    {/* Student: Enrollment Info */}
                    {selectedUser.role === 'student' && (
                      <div className="space-y-3">
                        <h3 className="text-sm font-bold text-yellow-400 uppercase tracking-wide">Enrollment Information</h3>
                        <div>
                          <label className="block text-xs font-semibold text-gray-400 mb-1 uppercase tracking-wide">Active Courses</label>
                          <div className="bg-gray-800 border border-gray-600 rounded-lg px-4 py-3 text-sm text-gray-300">
                            {(selectedUser.enrolled_courses || []).length > 0
                              ? (selectedUser.enrolled_courses || [])
                                  .map((courseId) => courses.find((c) => c.id === courseId)?.title || courseId)
                                  .join(', ')
                              : 'No active course enrollments'}
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                          <LabeledSelect
                            label="Enrollment Status"
                            value={selectedUser.enrollment_status}
                            onChange={(v) => setSelectedUser({ ...selectedUser, enrollment_status: v })}
                            options={[
                              { value: 'active', label: 'Active' },
                              { value: 'pending', label: 'Pending' },
                              { value: 'inactive', label: 'Inactive' },
                              { value: 'withdrawn', label: 'Withdrawn' },
                            ]}
                          />
                          <LabeledSelect
                            label="Student Status"
                            value={selectedUser.accountStatus}
                            onChange={(v) => setSelectedUser({ ...selectedUser, accountStatus: v })}
                            options={[
                              { value: 'active', label: 'Active' },
                              { value: 'suspended', label: 'Suspended' },
                              { value: 'inactive', label: 'Inactive' },
                            ]}
                          />
                        </div>
                        <LabeledSelect
                          label="Assigned Teacher"
                          value={selectedUser.assigned_teacher_id}
                          onChange={(v) => setSelectedUser({ ...selectedUser, assigned_teacher_id: v })}
                          options={[{ value: '', label: 'Unassigned' }, ...teachers.map((t) => ({ value: t.id, label: t.name || t.email }))]}
                        />
                      </div>
                    )}

                    {/* Teacher: Employment Info + Assigned Courses */}
                    {selectedUser.role === 'teacher' && (
                      <div className="space-y-3">
                        <h3 className="text-sm font-bold text-yellow-400 uppercase tracking-wide">Employment Information</h3>
                        <div className="grid grid-cols-2 gap-3">
                          <LabeledSelect
                            label="Employment Status"
                            value={selectedUser.employment_status}
                            onChange={(v) => setSelectedUser({ ...selectedUser, employment_status: v })}
                            options={[
                              { value: 'full_time', label: 'Full-Time' },
                              { value: 'part_time', label: 'Part-Time' },
                              { value: 'contract', label: 'Contract' },
                              { value: 'inactive', label: 'Inactive' },
                            ]}
                          />
                          <LabeledSelect
                            label="Account Status"
                            value={selectedUser.accountStatus}
                            onChange={(v) => setSelectedUser({ ...selectedUser, accountStatus: v })}
                            options={[
                              { value: 'active', label: 'Active' },
                              { value: 'suspended', label: 'Suspended' },
                              { value: 'inactive', label: 'Inactive' },
                            ]}
                          />
                        </div>
                        <LabeledInput label="Teaching Availability" value={selectedUser.teaching_availability} onChange={(v) => setSelectedUser({ ...selectedUser, teaching_availability: v })} placeholder="e.g. Mon-Fri 9am-5pm EST" />

                        <AssignedCoursesPicker
                          courses={courses}
                          selectedIds={selectedUser.assigned_course_ids}
                          onChange={(nextIds) => setSelectedUser({ ...selectedUser, assigned_course_ids: nextIds })}
                          searchValue={editCourseSearch}
                          onSearchChange={setEditCourseSearch}
                          sortOrder={editCourseSort}
                          onSortChange={setEditCourseSort}
                          error={editErrors.assigned_course_ids}
                        />
                      </div>
                    )}

                    <div className="flex gap-3 pt-2">
                      <button
                        onClick={handleUpdateUser}
                        disabled={savingUser}
                        className="flex-1 bg-yellow-500 hover:bg-yellow-600 disabled:opacity-60 disabled:cursor-not-allowed text-black py-3 rounded-lg font-bold"
                      >
                        {savingUser ? 'Saving...' : 'Save User'}
                      </button>
                      <button onClick={() => setSelectedUser(null)} disabled={savingUser} className="px-4 py-3 border border-gray-600 rounded-lg text-gray-300">Close</button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>
        )}

        {activeTab === 'parents' && (
          <section className="grid grid-cols-1 xl:grid-cols-3 gap-6">
            <div className="xl:col-span-2 bg-gray-900 border border-yellow-400/20 rounded-2xl p-6">
              <div className="flex flex-col md:flex-row md:items-center gap-3 mb-5">
                <div>
                  <h2 className="text-xl font-bold text-yellow-400">Parents / Guardians</h2>
                  <p className="text-sm text-gray-400">Private contact information associated with student records.</p>
                </div>
                <input value={parentSearch} onChange={(e) => setParentSearch(e.target.value)} className="md:ml-auto w-full md:w-80 bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Search parent, phone, or student" />
              </div>
              <div className="space-y-3">
                {filteredParentDirectory.length === 0 ? (
                  <div className="rounded-xl border border-gray-700 bg-gray-800 p-5 text-gray-400">No parent or guardian information is available for the current search.</div>
                ) : filteredParentDirectory.map(({ student, parent }) => (
                  <div key={student.id} className="rounded-xl border border-gray-700 bg-gray-800 p-4">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
                      <div>
                        <div className="text-white font-semibold">{[parent.first_name, parent.last_name].filter(Boolean).join(' ') || 'Not provided'}</div>
                        <div className="text-gray-300 text-sm">Student: {student.name || student.email}</div>
                        <div className="text-gray-400 text-sm">{parent.email || 'Not provided'} • {parent.cell_phone || 'Not provided'}</div>
                      </div>
                      <button type="button" onClick={() => setSelectedParent({ student, parent })} className="border border-yellow-400 text-yellow-300 hover:bg-yellow-400 hover:text-black px-3 py-2 rounded-lg text-sm">View</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6">
              <h2 className="text-xl font-bold text-yellow-400 mb-4">Parent / Guardian Details</h2>
              {!selectedParent ? (
                <p className="text-gray-400">Select View to inspect the associated student and contact details.</p>
              ) : (
                <div className="space-y-5 text-sm">
                  <div>
                    <h3 className="text-yellow-300 font-semibold mb-2">Parent / Guardian</h3>
                    <div className="text-gray-300">Full Name: {[selectedParent.parent.first_name, selectedParent.parent.last_name].filter(Boolean).join(' ') || 'Not provided'}</div>
                    <div className="text-gray-300">Email: {selectedParent.parent.email || 'Not provided'}</div>
                    <div className="text-gray-300">Cell Phone: {selectedParent.parent.cell_phone || 'Not provided'}</div>
                    <div className="text-gray-300">Work Phone: {selectedParent.parent.work_phone || 'Not provided'}</div>
                    <div className="text-gray-300">Home Phone: {selectedParent.parent.home_phone || 'Not provided'}</div>
                  </div>
                  <div>
                    <h3 className="text-yellow-300 font-semibold mb-2">Associated Student</h3>
                    <div className="text-gray-300">Name: {selectedParent.student.name || 'Not provided'}</div>
                    <div className="text-gray-300">Email: {selectedParent.student.email || 'Not provided'}</div>
                    <div className="text-gray-300">Student ID: {selectedParent.student.id || 'Not provided'}</div>
                    <div className="text-gray-300">Enrolled Courses: {selectedParent.student.enrolled_count || 0}</div>
                  </div>
                  <div>
                    <h3 className="text-yellow-300 font-semibold mb-2">Emergency Contact</h3>
                    <div className="text-gray-300">Name: {selectedParent.student.emergency_contact?.name || selectedParent.student.emergency_contact_name || 'Not provided'}</div>
                    <div className="text-gray-300">Phone: {selectedParent.student.emergency_contact?.phone_number || selectedParent.student.emergency_contact_phone || 'Not provided'}</div>
                  </div>
                  <div>
                    <h3 className="text-yellow-300 font-semibold mb-2">Secondary Contact</h3>
                    <div className="text-gray-300">Name: {selectedParent.student.secondary_contact?.name || 'Not provided'}</div>
                    <div className="text-gray-300">Phone: {selectedParent.student.secondary_contact?.phone_number || 'Not provided'}</div>
                  </div>
                </div>
              )}
            </div>
          </section>
        )}

        {activeTab === 'employees' && (
          <section className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-5">
                <div className="text-xs uppercase tracking-wide text-gray-400">Total Tasks</div>
                <div className="text-3xl font-bold text-yellow-400 mt-1">{employeeTasks.length}</div>
              </div>
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-5">
                <div className="text-xs uppercase tracking-wide text-gray-400">Pending</div>
                <div className="text-3xl font-bold text-yellow-400 mt-1">{employeeTasks.filter((task) => ['pending', 'not_started'].includes(String(task.status || '').toLowerCase())).length}</div>
              </div>
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-5">
                <div className="text-xs uppercase tracking-wide text-gray-400">In Progress</div>
                <div className="text-3xl font-bold text-yellow-400 mt-1">{employeeTasks.filter((task) => ['in_progress', 'started', 'waiting_for_review'].includes(String(task.status || '').toLowerCase())).length}</div>
              </div>
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-5">
                <div className="text-xs uppercase tracking-wide text-gray-400">Completed</div>
                <div className="text-3xl font-bold text-yellow-400 mt-1">{employeeTasks.filter((task) => String(task.status || '').toLowerCase() === 'completed').length}</div>
              </div>
            </div>

            <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-4">
                <h2 className="text-xl font-bold text-yellow-400">Departments</h2>
                <p className="text-sm text-gray-400">Create departments to organize employees. Assign a department to each employee from the Users tab.</p>
                <div className="flex flex-col md:flex-row gap-3">
                  <input value={deptForm.name} onChange={(e) => setDeptForm({ ...deptForm, name: e.target.value })} className="flex-1 bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Department name" />
                  <input value={deptForm.description} onChange={(e) => setDeptForm({ ...deptForm, description: e.target.value })} className="flex-1 bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Description (optional)" />
                  <button onClick={handleCreateDepartment} className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 py-3 rounded-lg font-bold whitespace-nowrap">Add Department</button>
                </div>
                <div className="space-y-2 max-h-72 overflow-y-auto pr-1">
                  {departments.length === 0 ? (
                    <div className="text-sm text-gray-500">No departments yet.</div>
                  ) : (
                    departments.map((dept) => (
                      <div key={dept.id} className="bg-gray-800 rounded-xl p-3">
                        <div className="text-white font-semibold text-sm">{dept.name}</div>
                        {dept.description && <div className="text-xs text-gray-400 mt-1">{dept.description}</div>}
                      </div>
                    ))
                  )}
                </div>
              </div>

              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-4">
                <h2 className="text-xl font-bold text-yellow-400">Assign Employee Task</h2>
                <p className="text-sm text-gray-400">Assign responsibilities with deadlines and priority.</p>
                <div className="space-y-3">
                  <select value={taskAssignForm.employee_id} onChange={(e) => setTaskAssignForm({ ...taskAssignForm, employee_id: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                    <option value="">Select employee</option>
                    {users.filter((u) => (u.role || '').toLowerCase() === 'employee').map((u) => (
                      <option key={u.id} value={u.id}>{u.name || u.email}</option>
                    ))}
                  </select>
                  <input value={taskAssignForm.title} onChange={(e) => setTaskAssignForm({ ...taskAssignForm, title: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Task title" />
                  <textarea value={taskAssignForm.description} onChange={(e) => setTaskAssignForm({ ...taskAssignForm, description: e.target.value })} rows={2} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Description (optional)" />
                  <div className="grid grid-cols-2 gap-3">
                    <select value={taskAssignForm.priority} onChange={(e) => setTaskAssignForm({ ...taskAssignForm, priority: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                      <option value="low">Low</option>
                      <option value="medium">Medium</option>
                      <option value="high">High</option>
                      <option value="urgent">Urgent</option>
                    </select>
                    <select value={taskAssignForm.status} onChange={(e) => setTaskAssignForm({ ...taskAssignForm, status: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                      <option value="pending">Pending</option>
                      <option value="in_progress">In Progress</option>
                      <option value="completed">Completed</option>
                    </select>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <input type="date" value={taskAssignForm.start_date} onChange={(e) => setTaskAssignForm({ ...taskAssignForm, start_date: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" />
                    <input type="date" value={taskAssignForm.deadline} onChange={(e) => setTaskAssignForm({ ...taskAssignForm, deadline: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" />
                  </div>
                  <div className="space-y-2">
                    <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wide">Attachments</label>
                    <input
                      type="file"
                      multiple
                      onChange={(e) => handleUploadDraftTaskAttachments(e.target.files)}
                      className="w-full text-xs text-gray-300 file:mr-3 file:rounded-md file:border-0 file:bg-yellow-500 file:px-3 file:py-2 file:text-xs file:font-semibold file:text-black hover:file:bg-yellow-400"
                    />
                    {taskAttachmentUploading && <div className="text-xs text-gray-400">Uploading attachments...</div>}
                    {(taskAssignForm.attachments || []).length > 0 && (
                      <div className="space-y-2 max-h-28 overflow-y-auto pr-1">
                        {(taskAssignForm.attachments || []).map((attachment) => (
                          <div key={attachment.id} className="bg-gray-800 border border-gray-700 rounded-lg px-3 py-2 flex items-center justify-between gap-2">
                            <div className="min-w-0">
                              <div className="text-xs text-white truncate">{attachment.filename}</div>
                              <div className="text-[11px] text-gray-400">{formatAttachmentSize(attachment.size)} • {formatAttachmentDate(attachment.uploaded_at)}</div>
                            </div>
                            <button
                              type="button"
                              onClick={() => handleRemoveDraftAttachment(attachment.id)}
                              className="text-[11px] px-2 py-1 rounded border border-red-600 text-red-300 hover:bg-red-900/40"
                            >
                              Remove
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <button onClick={handleAssignEmployeeTask} className="w-full bg-yellow-500 hover:bg-yellow-600 text-black py-3 rounded-lg font-bold">Assign Task</button>
                </div>
              </div>

              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-4">
                <h2 className="text-xl font-bold text-yellow-400">Internal Messaging Broadcast</h2>
                <p className="text-sm text-gray-400">Send one message to one employee, multiple employees, or everyone at once.</p>
                <div className="space-y-3">
                  <label className="flex items-center gap-2 text-sm text-gray-300">
                    <input
                      type="checkbox"
                      checked={employeeBroadcastForm.send_to_all_employees}
                      onChange={(e) => setEmployeeBroadcastForm((current) => ({ ...current, send_to_all_employees: e.target.checked, employee_ids: e.target.checked ? [] : current.employee_ids }))}
                    />
                    Broadcast to all employees
                  </label>
                  {!employeeBroadcastForm.send_to_all_employees && (
                    <select
                      multiple
                      value={employeeBroadcastForm.employee_ids}
                      onChange={(e) => setEmployeeBroadcastForm((current) => ({ ...current, employee_ids: Array.from(e.target.selectedOptions || []).map((opt) => opt.value) }))}
                      className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600 min-h-[120px]"
                    >
                      {users.filter((u) => (u.role || '').toLowerCase() === 'employee').map((u) => (
                        <option key={u.id} value={u.id}>{u.name || u.email}</option>
                      ))}
                    </select>
                  )}
                  <input value={employeeBroadcastForm.title} onChange={(e) => setEmployeeBroadcastForm((current) => ({ ...current, title: e.target.value }))} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Message title" />
                  <textarea value={employeeBroadcastForm.message} onChange={(e) => setEmployeeBroadcastForm((current) => ({ ...current, message: e.target.value }))} rows={3} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Message content" />
                  <div className="space-y-2">
                    <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wide">Attachments</label>
                    <input
                      type="file"
                      multiple
                      onChange={(e) => handleUploadEmployeeMessageAttachments(e.target.files)}
                      className="w-full text-xs text-gray-300 file:mr-3 file:rounded-md file:border-0 file:bg-yellow-500 file:px-3 file:py-2 file:text-xs file:font-semibold file:text-black hover:file:bg-yellow-400"
                    />
                    {employeeMessageAttachmentUploading && <div className="text-xs text-gray-400">Uploading... {employeeMessageUploadProgress}%</div>}
                    {(employeeBroadcastForm.attachment_ids || []).length > 0 && (
                      <div className="text-xs text-gray-300">{employeeBroadcastForm.attachment_ids.length} attachment(s) ready</div>
                    )}
                  </div>
                  <button onClick={handleSendEmployeeMessage} className="w-full bg-yellow-500 hover:bg-yellow-600 text-black py-3 rounded-lg font-bold">Send Message</button>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-4">
                <h3 className="text-lg font-bold text-yellow-400">Schedule Employee Meeting</h3>
                <div className="space-y-3">
                  <input value={meetingForm.title} onChange={(e) => setMeetingForm({ ...meetingForm, title: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Meeting title" />
                  <textarea value={meetingForm.description} onChange={(e) => setMeetingForm({ ...meetingForm, description: e.target.value })} rows={2} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Description" />
                  <input type="datetime-local" value={meetingForm.meeting_at} onChange={(e) => setMeetingForm({ ...meetingForm, meeting_at: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" />
                  <input value={meetingForm.platform} onChange={(e) => setMeetingForm({ ...meetingForm, platform: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Platform (Google Meet, Zoom, etc.)" />
                  <input value={meetingForm.meeting_url} onChange={(e) => setMeetingForm({ ...meetingForm, meeting_url: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="https://meeting-link" />
                  <label className="flex items-center gap-2 text-sm text-gray-300">
                    <input
                      type="checkbox"
                      checked={meetingForm.send_to_all}
                      onChange={(e) => setMeetingForm({ ...meetingForm, send_to_all: e.target.checked, employee_ids: e.target.checked ? [] : meetingForm.employee_ids })}
                    />
                    Send to all employees
                  </label>
                  {!meetingForm.send_to_all && (
                    <select
                      multiple
                      value={meetingForm.employee_ids}
                      onChange={(e) => setMeetingForm({ ...meetingForm, employee_ids: Array.from(e.target.selectedOptions || []).map((opt) => opt.value) })}
                      className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600 min-h-[130px]"
                    >
                      {users.filter((u) => (u.role || '').toLowerCase() === 'employee').map((u) => (
                        <option key={`meeting-employee-${u.id}`} value={u.id}>{u.name || u.email}</option>
                      ))}
                    </select>
                  )}
                  <button onClick={handleCreateMeeting} className="w-full bg-yellow-500 hover:bg-yellow-600 text-black py-3 rounded-lg font-bold">Create Meeting</button>
                </div>
                <div className="space-y-2 max-h-64 overflow-y-auto pr-1">
                  {employeeMeetings.slice(0, 20).map((meeting) => (
                    <div key={meeting.id} className="bg-gray-800 rounded-xl p-3 text-sm border border-gray-700">
                      <div className="text-white font-medium">{meeting.title}</div>
                      <div className="text-xs text-gray-400 mt-1">{new Date(meeting.meeting_at).toLocaleString()} • {meeting.platform}</div>
                      <div className="text-xs text-gray-500 mt-1">Participants: {(meeting.participants || []).length}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6">
                <h3 className="text-lg font-bold text-yellow-400 mb-3">Internal Conversation Inbox</h3>
                <input
                  value={employeeConversationSearch}
                  onChange={(e) => setEmployeeConversationSearch(e.target.value)}
                  className="w-full bg-gray-800 text-white px-4 py-2 rounded-lg border border-gray-600 text-sm mb-3"
                  placeholder="Search conversations"
                />
                <div className="grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-3">
                  <div className="space-y-2 max-h-[560px] overflow-y-auto pr-1">
                    {employeeInbox.length === 0 ? (
                      <div className="text-sm text-gray-500">No employee conversations yet.</div>
                    ) : (
                      employeeInbox
                        .filter((thread) => {
                          const searchValue = employeeConversationSearch.trim().toLowerCase();
                          if (!searchValue) return true;
                          const haystack = [thread.display_name, thread.title, thread.last_message_preview]
                            .filter(Boolean)
                            .join(' ')
                            .toLowerCase();
                          return haystack.includes(searchValue);
                        })
                        .slice(0, 120)
                        .map((thread) => (
                          <button
                            key={thread.id}
                            type="button"
                            onClick={() => handleOpenEmployeeConversation(thread.id)}
                            className={`w-full text-left bg-gray-800 rounded-xl p-3 border ${selectedEmployeeConversationId === thread.id ? 'border-yellow-400' : 'border-gray-700 hover:border-yellow-500/60'}`}
                          >
                            <div className="flex justify-between gap-2 text-sm">
                              <div className="text-white font-medium line-clamp-1">{thread.display_name || thread.title || 'Conversation'}</div>
                              {thread.unread_count > 0 && <span className="text-[10px] bg-yellow-500 text-black px-2 py-0.5 rounded-full font-bold">{thread.unread_count}</span>}
                            </div>
                            <div className="text-xs text-gray-400 mt-1 line-clamp-2">{thread.last_message_preview || 'No messages yet'}</div>
                          </button>
                        ))
                    )}
                  </div>

                  <div className="bg-gray-800 rounded-xl border border-gray-700 p-3 space-y-3">
                    {!selectedEmployeeConversationId ? (
                      <div className="text-sm text-gray-500">Select a conversation to view and reply.</div>
                    ) : (
                      <>
                        <div className="flex flex-wrap items-center justify-between gap-2">
                          <div>
                            <div className="text-white font-semibold">{employeeConversationDetail?.display_name || employeeConversationDetail?.title || 'Conversation'}</div>
                            <div className="text-xs text-gray-400 mt-1">{(employeeConversationDetail?.participant_profiles || []).map((p) => p.name || p.email).join(', ')}</div>
                          </div>
                          <div className="flex gap-2">
                            <button onClick={() => handleSetEmployeeMessageStatus(selectedEmployeeConversationId, true)} className="px-3 py-1.5 rounded border border-blue-600 text-blue-300 text-xs">Pin</button>
                            <button onClick={() => handleSetEmployeeMessageStatus(selectedEmployeeConversationId, false)} className="px-3 py-1.5 rounded border border-gray-600 text-gray-200 text-xs">Unpin</button>
                            <button onClick={() => handleDeleteEmployeeConversation(selectedEmployeeConversationId)} className="px-3 py-1.5 rounded border border-red-600 text-red-300 text-xs">Delete</button>
                          </div>
                        </div>

                        <div className="space-y-2 max-h-[380px] overflow-y-auto pr-1">
                          {(employeeConversationMessages || []).length === 0 ? (
                            <div className="text-sm text-gray-500">No messages yet.</div>
                          ) : (
                            (employeeConversationMessages || []).map((msg) => (
                              <div key={msg.id} className="bg-gray-900 rounded-xl border border-gray-700 p-3">
                                <div className="flex items-center justify-between gap-2 flex-wrap">
                                  <div className="text-xs text-yellow-300 font-semibold">{msg.sender_name || 'User'} • {new Date(msg.created_at).toLocaleString()}</div>
                                  <button
                                    type="button"
                                    onClick={() => { setEditingMsgId(msg.id); setEditingMsgText(msg.message || ''); }}
                                    className="text-[10px] px-2 py-0.5 rounded border border-gray-600 text-gray-400 hover:text-yellow-300 hover:border-yellow-400"
                                  >Edit</button>
                                </div>
                                {editingMsgId === msg.id ? (
                                  <div className="mt-2 space-y-2">
                                    <textarea
                                      value={editingMsgText}
                                      onChange={(e) => setEditingMsgText(e.target.value)}
                                      rows={3}
                                      className="w-full bg-gray-800 text-white px-3 py-2 rounded-lg border border-yellow-500/50 text-sm"
                                    />
                                    <div className="flex gap-2">
                                      <button type="button" onClick={handleSaveMsgEdit} className="px-3 py-1 rounded bg-yellow-500 text-black text-xs font-semibold hover:bg-yellow-600">Save</button>
                                      <button type="button" onClick={() => { setEditingMsgId(''); setEditingMsgText(''); }} className="px-3 py-1 rounded border border-gray-600 text-gray-300 text-xs hover:bg-gray-700">Cancel</button>
                                    </div>
                                  </div>
                                ) : (
                                  msg.message && <div className="text-sm text-gray-100 mt-1 whitespace-pre-wrap">{msg.message}</div>
                                )}
                                {(msg.attachments || []).length > 0 && (
                                  <div className="mt-2 space-y-1.5">
                                    {(msg.attachments || []).map((attachment) => (
                                      <div key={attachment.id} className="flex items-center gap-2 bg-gray-800/60 rounded-lg px-2.5 py-1.5">
                                        <span className="text-xs text-gray-200 truncate flex-1">{attachment.filename || 'Attachment'}</span>
                                        <div className="flex gap-1.5 shrink-0">
                                          {(isImageAttachment(attachment) || isVideoAttachment(attachment)) && resolveAttachmentUrl(attachment, true) && (
                                            <button type="button" onClick={() => adminDownloadAttachment(attachment, true)} className="text-[10px] px-2 py-0.5 rounded border border-gray-600 text-gray-300 hover:border-yellow-400">Preview</button>
                                          )}
                                          <button type="button" onClick={() => adminDownloadAttachment(attachment, false)} className="text-[10px] px-2 py-0.5 rounded border border-gray-600 text-yellow-300 hover:border-yellow-400">Download</button>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ))
                          )}
                        </div>

                        {conversationReplyAttachmentDraft.length > 0 && (
                          <div className="flex flex-wrap gap-2">
                            {conversationReplyAttachmentDraft.map((att) => (
                              <div key={att.id} className="flex items-center gap-1.5 bg-gray-700 rounded-lg px-2 py-1 text-xs text-gray-200">
                                <span className="truncate max-w-[120px]">{att.filename}</span>
                                <button type="button" onClick={() => setConversationReplyAttachmentDraft((c) => c.filter((a) => a.id !== att.id))} className="text-red-400 hover:text-red-300 ml-1">✕</button>
                              </div>
                            ))}
                          </div>
                        )}
                        <textarea
                          value={employeeConversationReply}
                          onChange={(e) => setEmployeeConversationReply(e.target.value)}
                          rows={3}
                          className="w-full bg-gray-900 text-white px-3 py-2 rounded-lg border border-gray-600 text-sm"
                          placeholder="Reply to this conversation"
                        />
                        <div className="flex flex-wrap items-center gap-3">
                          <button onClick={handleReplyEmployeeMessage} className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 py-2 rounded-lg text-sm font-semibold">Send Reply</button>
                          <label className="cursor-pointer text-xs text-gray-300 border border-gray-600 px-3 py-2 rounded-lg hover:border-yellow-400">
                            {conversationReplyAttachmentUploading ? 'Uploading…' : '+ Attach File'}
                            <input type="file" multiple className="hidden" disabled={conversationReplyAttachmentUploading} onChange={(e) => handleUploadConversationReplyAttachments(e.target.files)} />
                          </label>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6">
              <h3 className="text-lg font-bold text-yellow-400 mb-3">Task Progress Monitor</h3>
              <div className="space-y-2 max-h-[420px] overflow-y-auto pr-1">
                {employeeTasks.length === 0 ? (
                  <div className="text-sm text-gray-500">No tasks assigned yet.</div>
                ) : (
                  employeeTasks.slice(0, 60).map((task) => (
                    <div key={task.id} className="bg-gray-800 rounded-xl p-3 text-sm border border-gray-700">
                      <div className="flex flex-wrap justify-between gap-2">
                        <div className="text-white font-medium">{task.title}</div>
                        <span className="text-xs text-gray-300">{task.employee_name || task.employee_email || task.employee_id}</span>
                      </div>
                      <div className="text-xs text-gray-400 mt-1">Status: {String(task.status || 'pending').replaceAll('_', ' ')} • Priority: {task.priority} • Start: {task.start_date || '—'} • Due: {task.deadline || '—'}</div>
                      {!taskEditById[task.id] ? (
                        <div className="mt-2">
                          <button
                            type="button"
                            onClick={() => openTaskEditor(task)}
                            className="px-3 py-1 rounded border border-yellow-500 text-yellow-300 hover:bg-yellow-500/10"
                          >
                            Edit Task
                          </button>
                        </div>
                      ) : (
                        <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-2">
                          <input
                            value={taskEditById[task.id]?.title || ''}
                            onChange={(e) => handleTaskEditField(task.id, 'title', e.target.value)}
                            className="bg-gray-900 text-white px-3 py-2 rounded border border-gray-600"
                            placeholder="Task title"
                          />
                          <select
                            value={taskEditById[task.id]?.priority || 'medium'}
                            onChange={(e) => handleTaskEditField(task.id, 'priority', e.target.value)}
                            className="bg-gray-900 text-white px-3 py-2 rounded border border-gray-600"
                          >
                            <option value="low">Low</option>
                            <option value="medium">Medium</option>
                            <option value="high">High</option>
                            <option value="urgent">Urgent</option>
                          </select>
                          <select
                            value={taskEditById[task.id]?.status || 'pending'}
                            onChange={(e) => handleTaskEditField(task.id, 'status', e.target.value)}
                            className="bg-gray-900 text-white px-3 py-2 rounded border border-gray-600"
                          >
                            <option value="pending">Pending</option>
                            <option value="in_progress">In Progress</option>
                            <option value="completed">Completed</option>
                          </select>
                          <input
                            type="date"
                            value={taskEditById[task.id]?.start_date || ''}
                            onChange={(e) => handleTaskEditField(task.id, 'start_date', e.target.value)}
                            className="bg-gray-900 text-white px-3 py-2 rounded border border-gray-600"
                          />
                          <input
                            type="date"
                            value={taskEditById[task.id]?.deadline || ''}
                            onChange={(e) => handleTaskEditField(task.id, 'deadline', e.target.value)}
                            className="bg-gray-900 text-white px-3 py-2 rounded border border-gray-600"
                          />
                          <textarea
                            value={taskEditById[task.id]?.description || ''}
                            onChange={(e) => handleTaskEditField(task.id, 'description', e.target.value)}
                            rows={2}
                            className="bg-gray-900 text-white px-3 py-2 rounded border border-gray-600 md:col-span-2"
                            placeholder="Task description"
                          />
                          <div className="md:col-span-2 flex gap-2">
                            <button
                              type="button"
                              onClick={() => handleSaveTaskEdit(task.id)}
                              disabled={savingTaskEditId === task.id}
                              className="px-3 py-2 rounded bg-yellow-500 text-black font-semibold hover:bg-yellow-600 disabled:opacity-60"
                            >
                              {savingTaskEditId === task.id ? 'Saving...' : 'Save Update'}
                            </button>
                            <button
                              type="button"
                              onClick={() => closeTaskEditor(task.id)}
                              disabled={savingTaskEditId === task.id}
                              className="px-3 py-2 rounded border border-gray-600 text-gray-300 hover:bg-gray-700 disabled:opacity-60"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      )}
                      {task.employee_note && <div className="text-xs text-gray-300 mt-2">Note: {task.employee_note}</div>}
                      {(task.employee_comments || []).length > 0 && <div className="text-xs text-gray-500 mt-1">Comments: {(task.employee_comments || []).length}</div>}
                      {(task.attachments || []).length > 0 && (
                        <div className="mt-2 space-y-2">
                          {(task.attachments || []).map((attachment) => (
                            <div key={attachment.id} className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-xs">
                              <div className="flex flex-wrap items-center justify-between gap-2">
                                <div className="text-gray-200 font-medium truncate">{attachment.filename}</div>
                                <div className="text-gray-500">{formatAttachmentSize(attachment.size)}</div>
                              </div>
                              <div className="text-gray-500 mt-1">Uploaded {formatAttachmentDate(attachment.uploaded_at)} by {attachment.uploaded_by_name || 'Admin'}</div>
                              <div className="flex gap-2 mt-2">
                                {isImageAttachment(attachment) && resolveAttachmentUrl(attachment, true) && (
                                  <button
                                    type="button"
                                    onClick={() => adminDownloadAttachment(attachment, true)}
                                    className="px-2 py-1 rounded border border-gray-600 text-gray-200 hover:border-yellow-400"
                                  >
                                    Preview
                                  </button>
                                )}
                                {resolveAttachmentUrl(attachment, false) && (
                                  <button
                                    type="button"
                                    onClick={() => adminDownloadAttachment(attachment, false)}
                                    className="px-2 py-1 rounded border border-gray-600 text-yellow-300 hover:border-yellow-400"
                                  >
                                    Download
                                  </button>
                                )}
                                <button
                                  type="button"
                                  onClick={() => handleRemoveTaskAttachment(task.id, attachment.id)}
                                  disabled={taskAttachmentUpdatingId === task.id}
                                  className="px-2 py-1 rounded border border-red-600 text-red-300 hover:bg-red-900/40 disabled:opacity-60"
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      <div className="mt-2">
                        <input
                          type="file"
                          onChange={(e) => handleUploadAttachmentToExistingTask(task.id, e.target.files?.[0])}
                          className="w-full text-xs text-gray-300 file:mr-3 file:rounded-md file:border-0 file:bg-yellow-500 file:px-3 file:py-2 file:text-xs file:font-semibold file:text-black hover:file:bg-yellow-400"
                        />
                        {taskAttachmentUpdatingId === task.id && <div className="text-xs text-gray-500 mt-1">Updating attachments...</div>}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </section>
        )}

        {activeTab === 'courses' && (
          <section className="grid grid-cols-1 xl:grid-cols-3 gap-6">
            <div className="xl:col-span-2 bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3 max-h-[780px] overflow-y-auto pr-1">
              <div className="sticky top-0 z-10 bg-gray-900 pb-2">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                  <input
                    value={teacherCourseSearch}
                    onChange={(e) => setTeacherCourseSearch(e.target.value)}
                    className="bg-gray-800 text-white px-4 py-2 rounded-lg border border-gray-600"
                    placeholder="Search courses by title or keyword"
                  />
                  <select
                    value={courseGroupFilter}
                    onChange={(e) => {
                      setCourseGroupFilter(e.target.value);
                      setCourseCategoryFilter('all');
                    }}
                    className="bg-gray-800 text-white px-4 py-2 rounded-lg border border-gray-600"
                  >
                    <option value="all">All Groups</option>
                    {availableCourseGroups.map((group) => <option key={`admin-group-${group}`} value={group}>{group}</option>)}
                  </select>
                  <select
                    value={courseCategoryFilter}
                    onChange={(e) => setCourseCategoryFilter(e.target.value)}
                    className="bg-gray-800 text-white px-4 py-2 rounded-lg border border-gray-600"
                  >
                    <option value="all">All Categories</option>
                    {availableCourseCategories
                      .filter((category) => {
                        if (courseGroupFilter === 'all') return true;
                        return courses.some((course) => String(course.category || '').trim() === category && String(course.catalog_group || course.catalogGroup || '').trim() === courseGroupFilter);
                      })
                      .map((category) => <option key={`admin-category-${category}`} value={category}>{category}</option>)}
                  </select>
                </div>
              </div>
              {courses
                .filter((course) => {
                  const matchesGroup = courseGroupFilter === 'all' || String(course.catalog_group || course.catalogGroup || '').trim() === courseGroupFilter;
                  const matchesCategory = courseCategoryFilter === 'all' || String(course.category || '').trim() === courseCategoryFilter;
                  const term = teacherCourseSearch.trim().toLowerCase();
                  const searchable = [course.title, course.description, course.catalog_group, course.catalogGroup, course.category, course.subject, course.level, course.best_for]
                    .filter(Boolean)
                    .join(' ')
                    .toLowerCase();
                  const matchesSearch = !term || searchable.includes(term);
                  return matchesGroup && matchesCategory && matchesSearch;
                })
                .map((course) => (
                <div key={course.id} className="bg-gray-800 rounded-xl p-4">
                  <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                    <div>
                      <div className="text-white font-semibold">{course.title}</div>
                      <div className="text-gray-400 text-sm">{(course.catalog_group || course.catalogGroup || 'General')} • {course.category || 'General'} • {(course.difficulty_level || course.level || 'Beginner')}</div>
                      <div className="text-gray-500 text-xs mt-1">Teachers: {(course.assigned_teachers || []).map((item) => item.name).filter(Boolean).join(', ') || course.teacher_name || course.instructor || 'Unassigned'}</div>
                      <div className="text-gray-500 text-xs mt-1">Status: {course.status || 'draft'} • Availability: {course.availability_status || 'open'} • Delivery: {course.delivery_mode || 'online'}</div>
                    </div>
                    <div className="flex gap-2 flex-wrap">
                      <button onClick={() => {
                        setSelectedCourse(course);
                        setCourseForm({
                          ...defaultCourseForm,
                          ...course,
                          catalog_group: course.catalog_group || course.catalogGroup || defaultCourseForm.catalog_group,
                          subject: course.subject || defaultCourseForm.subject,
                          teacher_ids: (course.assigned_teacher_ids || (course.teacher_id ? [course.teacher_id] : [])).filter(Boolean),
                          teacher_id: course.teacher_id || '',
                          price: String(course.price || 0),
                          estimated_hours: String(course.estimated_hours || 0),
                          learning_objectives: (course.learning_objectives || []).join('\n'),
                          prerequisites: (course.prerequisites || []).join('\n'),
                          learning_outcomes: (course.learning_outcomes || []).join('\n'),
                          projects: (course.projects || course.projects_activities || []).join('\n'),
                          career_paths: (course.career_paths || course.potential_career_paths || []).join('\n'),
                          best_for: course.best_for || '',
                          difficulty_level: course.difficulty_level || course.level || 'Beginner',
                          thumbnail_url: course.thumbnail_url || '',
                        });
                      }} className="border border-yellow-400 text-yellow-400 px-3 py-2 rounded-lg text-sm">Edit</button>
                      <button onClick={() => setCourseStatus(course.id, 'published', 'open')} className="bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded-lg text-sm">Publish</button>
                      <button onClick={() => setCourseStatus(course.id, 'published', 'waitlist')} className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-lg text-sm">Waitlist</button>
                      <button onClick={() => setCourseStatus(course.id, 'published', 'closed')} className="bg-orange-600 hover:bg-orange-700 text-white px-3 py-2 rounded-lg text-sm">Close</button>
                      <button onClick={() => setCourseStatus(course.id, 'archived', 'archived')} className="bg-gray-700 hover:bg-gray-600 text-white px-3 py-2 rounded-lg text-sm">Archive</button>
                      <button onClick={() => deleteCourse(course.id)} className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg text-sm">Delete</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3">
              <h2 className="text-xl font-bold text-yellow-400">{selectedCourse ? 'Edit Course' : 'Create Course'}</h2>
              <select
                value={courseForm.catalog_group || 'Robotics'}
                onChange={(e) => {
                  const nextGroup = e.target.value;
                  const nextCategoryOptions = CATEGORY_OPTIONS_BY_GROUP[nextGroup] || ROBOTICS_CATEGORY_OPTIONS;
                  setCourseForm({
                    ...courseForm,
                    catalog_group: nextGroup,
                    category: nextCategoryOptions[0]?.value || courseForm.category,
                  });
                }}
                className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600"
              >
                {CATALOG_GROUP_OPTIONS.map((option) => <option key={`catalog-group-${option.value}`} value={option.value}>{option.label}</option>)}
              </select>
              <select value={courseForm.subject} onChange={(e) => setCourseForm({ ...courseForm, subject: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                {SUBJECT_OPTIONS.map((option) => <option key={`subject-${option.value}`} value={option.value}>{option.label}</option>)}
              </select>
              <input value={courseForm.title} onChange={(e) => setCourseForm({ ...courseForm, title: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Course title" />
              <textarea value={courseForm.description} onChange={(e) => setCourseForm({ ...courseForm, description: e.target.value })} rows={4} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Course description" />
              <input value={courseForm.best_for} onChange={(e) => setCourseForm({ ...courseForm, best_for: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Best for" />
              <div className="grid grid-cols-2 gap-3">
                <select value={courseForm.category} onChange={(e) => setCourseForm({ ...courseForm, category: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                  {selectableCategoryOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
                </select>
                <input value={courseForm.duration} onChange={(e) => setCourseForm({ ...courseForm, duration: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Duration" />
                <select value={courseForm.difficulty_level || courseForm.level} onChange={(e) => setCourseForm({ ...courseForm, difficulty_level: e.target.value, level: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                  {selectableCategoryOptions.map((option) => <option key={`difficulty-${option.value}`} value={option.label}>{option.label}</option>)}
                </select>
                <input value={courseForm.price} onChange={(e) => setCourseForm({ ...courseForm, price: e.target.value })} type="number" className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Price" />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <select value={courseForm.teacher_id || ''} onChange={(e) => {
                  const primaryTeacherId = e.target.value;
                  const existing = (courseForm.teacher_ids || []).filter((id) => id !== primaryTeacherId);
                  setCourseForm({
                    ...courseForm,
                    teacher_id: primaryTeacherId,
                    teacher_ids: primaryTeacherId ? [primaryTeacherId, ...existing] : existing,
                  });
                }} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                  <option value="">Primary teacher (optional)</option>
                  {teachers.map((teacher) => <option key={teacher.id} value={teacher.id}>{teacher.name}</option>)}
                </select>
                <select value={courseForm.delivery_mode} onChange={(e) => setCourseForm({ ...courseForm, delivery_mode: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                  <option value="online">Online</option>
                  <option value="in_person">In-Person</option>
                  <option value="hybrid">Hybrid</option>
                </select>
                <select value={courseForm.status} onChange={(e) => setCourseForm({ ...courseForm, status: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                  <option value="draft">Draft</option>
                  <option value="published">Published</option>
                </select>
                <select value={courseForm.availability_status} onChange={(e) => setCourseForm({ ...courseForm, availability_status: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                  {AVAILABILITY_OPTIONS.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-400 mb-1 uppercase tracking-wide">Assigned Teacher(s)</label>
                <div className="max-h-40 overflow-y-auto rounded-lg border border-gray-700 bg-gray-800 p-3 space-y-2">
                  {teachers.map((teacher) => {
                    const checked = (courseForm.teacher_ids || []).includes(teacher.id);
                    return (
                      <label key={`course-teacher-${teacher.id}`} className="flex items-center gap-2 text-sm text-gray-200">
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={(e) => {
                            const next = e.target.checked
                              ? [...new Set([...(courseForm.teacher_ids || []), teacher.id])]
                              : (courseForm.teacher_ids || []).filter((id) => id !== teacher.id);
                            setCourseForm({
                              ...courseForm,
                              teacher_ids: next,
                              teacher_id: courseForm.teacher_id && !next.includes(courseForm.teacher_id) ? (next[0] || '') : courseForm.teacher_id,
                            });
                          }}
                          className="h-4 w-4 rounded border-gray-500 text-yellow-500 focus:ring-yellow-500"
                        />
                        <span>{teacher.name} <span className="text-xs text-gray-400">({teacher.email})</span></span>
                      </label>
                    );
                  })}
                  {teachers.length === 0 && <div className="text-xs text-gray-400">Create teacher accounts first to assign courses.</div>}
                </div>
              </div>
              <textarea value={courseForm.learning_objectives} onChange={(e) => setCourseForm({ ...courseForm, learning_objectives: e.target.value })} rows={4} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="One learning objective per line" />
              <textarea value={courseForm.prerequisites} onChange={(e) => setCourseForm({ ...courseForm, prerequisites: e.target.value })} rows={3} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Prerequisites (one per line)" />
              <textarea value={courseForm.learning_outcomes} onChange={(e) => setCourseForm({ ...courseForm, learning_outcomes: e.target.value })} rows={3} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="What students will learn (one per line)" />
              <textarea value={courseForm.projects} onChange={(e) => setCourseForm({ ...courseForm, projects: e.target.value })} rows={3} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Projects / practical work (one per line)" />
              <textarea value={courseForm.career_paths} onChange={(e) => setCourseForm({ ...courseForm, career_paths: e.target.value })} rows={3} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Possible career paths (one per line)" />
              <input value={courseForm.thumbnail_url} onChange={(e) => setCourseForm({ ...courseForm, thumbnail_url: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Course thumbnail URL (optional)" />
              <div className="flex gap-3">
                <button onClick={handleSaveCourse} className="flex-1 bg-yellow-500 hover:bg-yellow-600 text-black py-3 rounded-lg font-bold">{selectedCourse ? 'Save Course' : 'Create Course'}</button>
                {selectedCourse && <button onClick={() => { setSelectedCourse(null); setCourseForm(defaultCourseForm); }} className="px-4 py-3 border border-gray-600 rounded-lg text-gray-300">Close</button>}
              </div>
            </div>
          </section>
        )}

        {activeTab === 'jobs' && (
          <section className="space-y-6">
            <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
              <div className="xl:col-span-2 bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3 max-h-[760px] overflow-y-auto pr-1">
                {jobs.map((job) => (
                  <div key={job.id} className="bg-gray-800 rounded-xl p-4">
                    <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                      <div>
                        <div className="text-white font-semibold text-lg">{job.title}</div>
                        <div className="text-gray-400 text-sm">{job.company} • {job.location}</div>
                        <div className="text-gray-500 text-xs mt-1">{job.employment_type} • {job.remote_hybrid_status || 'Remote / Hybrid'} • {job.status || 'open'}</div>
                      </div>
                      <div className="flex gap-2 flex-wrap">
                        <button onClick={() => { setSelectedJob(job); setJobForm({ ...defaultJobForm, ...job, responsibilities: (job.responsibilities || []).join('\n'), qualifications: (job.qualifications || []).join('\n'), preferred_qualifications: (job.preferred_qualifications || []).join('\n'), benefits: (job.benefits || []).join('\n'), application_requirements: (job.application_requirements || []).join('\n'), application_deadline: job.application_deadline ? new Date(job.application_deadline).toISOString().slice(0, 10) : '' }); }} className="border border-yellow-400 text-yellow-400 px-3 py-2 rounded-lg text-sm">Edit</button>
                        <button onClick={() => toggleJobStatus(job.id, 'open')} className="bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded-lg text-sm">Open</button>
                        <button onClick={() => toggleJobStatus(job.id, 'closed')} className="bg-orange-600 hover:bg-orange-700 text-white px-3 py-2 rounded-lg text-sm">Close</button>
                        <button onClick={() => deleteJob(job.id)} className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg text-sm">Delete</button>
                      </div>
                    </div>
                  </div>
                ))}
                {!jobs.length && <div className="text-gray-400">No jobs found.</div>}
              </div>
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3">
                <h2 className="text-xl font-bold text-yellow-400">{selectedJob ? 'Edit Job' : 'Create Job'}</h2>
                <input value={jobForm.title} onChange={(e) => setJobForm({ ...jobForm, title: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Job title" />
                <input value={jobForm.company} onChange={(e) => setJobForm({ ...jobForm, company: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Company" />
                <input value={jobForm.location} onChange={(e) => setJobForm({ ...jobForm, location: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Location" />
                <div className="grid grid-cols-2 gap-3">
                  <input value={jobForm.employment_type} onChange={(e) => setJobForm({ ...jobForm, employment_type: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Employment type" />
                  <input value={jobForm.remote_hybrid_status} onChange={(e) => setJobForm({ ...jobForm, remote_hybrid_status: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Remote / Hybrid" />
                </div>
                <textarea value={jobForm.description} onChange={(e) => setJobForm({ ...jobForm, description: e.target.value })} rows={4} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Job description" />
                <textarea value={jobForm.responsibilities} onChange={(e) => setJobForm({ ...jobForm, responsibilities: e.target.value })} rows={5} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Responsibilities, one per line" />
                <textarea value={jobForm.qualifications} onChange={(e) => setJobForm({ ...jobForm, qualifications: e.target.value })} rows={5} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Qualifications, one per line" />
                <textarea value={jobForm.preferred_qualifications} onChange={(e) => setJobForm({ ...jobForm, preferred_qualifications: e.target.value })} rows={4} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Preferred qualifications, one per line" />
                <textarea value={jobForm.benefits} onChange={(e) => setJobForm({ ...jobForm, benefits: e.target.value })} rows={4} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Benefits, one per line" />
                <textarea value={jobForm.application_requirements} onChange={(e) => setJobForm({ ...jobForm, application_requirements: e.target.value })} rows={4} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Application requirements, one per line" />
                <input value={jobForm.compensation} onChange={(e) => setJobForm({ ...jobForm, compensation: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Compensation" />
                <div className="grid grid-cols-2 gap-3">
                  <input value={jobForm.application_deadline} onChange={(e) => setJobForm({ ...jobForm, application_deadline: e.target.value })} type="date" className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" />
                  <select value={jobForm.status} onChange={(e) => setJobForm({ ...jobForm, status: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                    <option value="open">Open</option>
                    <option value="closed">Closed</option>
                  </select>
                </div>
                <div className="flex gap-3">
                  <button onClick={handleSaveJob} className="flex-1 bg-yellow-500 hover:bg-yellow-600 text-black py-3 rounded-lg font-bold">{selectedJob ? 'Save Job' : 'Create Job'}</button>
                  {selectedJob && <button onClick={() => { setSelectedJob(null); setJobForm(defaultJobForm); }} className="px-4 py-3 border border-gray-600 rounded-lg text-gray-300">Close</button>}
                </div>
              </div>
            </div>

            <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3">
              <h2 className="text-xl font-bold text-yellow-400">Applications</h2>
              <div className="space-y-3 max-h-[540px] overflow-y-auto pr-1">
                {jobApplications.map((application) => (
                  <div key={application.id} className="bg-gray-800 rounded-xl p-4 flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
                    <div>
                      <div className="text-white font-semibold">{application.applicant_name}</div>
                      <div className="text-gray-400 text-sm">{application.job_title || 'Job'} • {application.email}</div>
                      <div className="text-gray-500 text-xs mt-1">Submitted {application.created_at ? new Date(application.created_at).toLocaleString() : 'recently'}</div>
                      <div className="text-gray-300 text-sm mt-2">Phone: {application.phone || 'n/a'} • Availability: {application.availability || 'n/a'}</div>
                      <div className="text-gray-300 text-sm mt-2">Application Status: <span className="text-green-400">Received ✅</span></div>
                      <div className="text-gray-300 text-sm mt-1">
                        Confirmation Email:{' '}
                        {application.confirmation_email_status === 'sent' && <span className="text-green-400">Sent ✅</span>}
                        {application.confirmation_email_status === 'failed' && <span className="text-red-400">Failed - Retry</span>}
                        {application.confirmation_email_status === 'not_configured' && <span className="text-orange-400">Not Configured</span>}
                        {(!application.confirmation_email_status || application.confirmation_email_status === 'pending') && <span className="text-yellow-400">Pending</span>}
                      </div>
                      <div className="flex flex-wrap gap-3 mt-3 text-sm">
                        {application.resume && (
                          <a
                            href={`${API}/admin/job-applications/${application.id}/download-resume`}
                            target="_blank"
                            rel="noreferrer"
                            className="text-yellow-400 hover:text-yellow-300 underline"
                            onClick={(e) => {
                              e.preventDefault();
                              const token = localStorage.getItem('token');
                              fetch(`${API}/admin/job-applications/${application.id}/download-resume`, {
                                headers: { Authorization: `Bearer ${token}` },
                              })
                                .then((res) => {
                                  if (!res.ok) throw new Error('File not found');
                                  return res.blob();
                                })
                                .then((blob) => {
                                  const url = window.URL.createObjectURL(blob);
                                  const a = document.createElement('a');
                                  a.href = url;
                                  a.download = application.resume.split('/').pop() || 'resume';
                                  document.body.appendChild(a);
                                  a.click();
                                  a.remove();
                                  window.URL.revokeObjectURL(url);
                                })
                                .catch(() => alert('Resume file not found on server'));
                            }}
                          >
                            ⬇ Download Resume
                          </a>
                        )}
                        {application.portfolio && <a href={application.portfolio} target="_blank" rel="noreferrer" className="text-yellow-400 hover:text-yellow-300 underline">Review Portfolio</a>}
                        {application.linked_in_url && <a href={application.linked_in_url} target="_blank" rel="noreferrer" className="text-yellow-400 hover:text-yellow-300 underline">LinkedIn</a>}
                        {application.website_url && <a href={application.website_url} target="_blank" rel="noreferrer" className="text-yellow-400 hover:text-yellow-300 underline">Website</a>}
                      </div>
                    </div>
                    <div className="flex flex-col gap-2 min-w-[180px]">
                      <select value={application.status || 'new'} onChange={(e) => updateApplicationStatus(application.id, e.target.value)} className="bg-gray-900 text-white px-4 py-3 rounded-lg border border-gray-600">
                        <option value="new">New</option>
                        <option value="reviewing">Reviewing</option>
                        <option value="interview">Interview</option>
                        <option value="accepted">Accepted</option>
                        <option value="rejected">Rejected</option>
                      </select>
                      <button onClick={() => resendConfirmationEmail(application.id)} className="border border-yellow-400 text-yellow-400 px-3 py-2 rounded-lg text-sm hover:bg-yellow-400 hover:text-black transition-colors">
                        Resend Confirmation Email
                      </button>
                    </div>
                  </div>
                ))}
                {!jobApplications.length && <div className="text-gray-400">No applications yet.</div>}
              </div>
            </div>
          </section>
        )}

        {activeTab === 'hackathons' && (
          <section className="space-y-6">
            <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
              <div className="xl:col-span-2 bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3 max-h-[760px] overflow-y-auto pr-1">
                <div className="flex items-center justify-between gap-3 flex-wrap">
                  <div>
                    <h2 className="text-xl font-bold text-yellow-400">Hackathons</h2>
                    <p className="text-sm text-gray-400">Manage the public robotics event and any future hackathons from one place.</p>
                  </div>
                  <button onClick={startNewHackathon} className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 py-2 rounded-lg font-semibold text-sm">New Hackathon</button>
                </div>
                {hackathons.map((hackathon) => (
                  <div key={hackathon.id} className={`rounded-2xl border p-4 transition-colors ${selectedHackathonId === hackathon.id ? 'border-yellow-400 bg-gray-800' : 'border-gray-700 bg-gray-800/80'}`}>
                    <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                      <button type="button" onClick={() => setSelectedHackathonId(hackathon.id)} className="text-left flex-1">
                        <div className="text-white font-semibold text-lg">{hackathon.title}</div>
                        <div className="text-gray-400 text-sm mt-1">{hackathon.tagline || hackathon.description}</div>
                        <div className="text-gray-500 text-xs mt-2">Apply by {formatHackathonDate(hackathon.application_deadline)} • {hackathon.location || hackathon.format || 'Online'} • {hackathon.status || 'upcoming'}</div>
                        <div className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
                          <div className="rounded-lg bg-black/30 px-3 py-2 text-gray-200">Total: {hackathon.application_count || 0}</div>
                          <div className="rounded-lg bg-black/30 px-3 py-2 text-gray-200">New: {hackathon.application_stats?.new || 0}</div>
                          <div className="rounded-lg bg-black/30 px-3 py-2 text-gray-200">Reviewed: {hackathon.application_stats?.reviewed || 0}</div>
                          <div className="rounded-lg bg-black/30 px-3 py-2 text-gray-200">Accepted: {hackathon.application_stats?.accepted || 0}</div>
                        </div>
                      </button>
                      <div className="flex gap-2 flex-wrap lg:justify-end">
                        <button onClick={() => editHackathon(hackathon)} className="border border-yellow-400 text-yellow-400 px-3 py-2 rounded-lg text-sm">Edit</button>
                        <button onClick={() => runHackathonAction('publish', hackathon.id)} className="bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded-lg text-sm">Publish</button>
                        <button onClick={() => runHackathonAction('close', hackathon.id)} className="bg-orange-600 hover:bg-orange-700 text-white px-3 py-2 rounded-lg text-sm">Close</button>
                        <button onClick={() => runHackathonAction('delete', hackathon.id)} className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg text-sm">Delete</button>
                      </div>
                    </div>
                  </div>
                ))}
                {!hackathons.length && <div className="text-gray-400">No hackathons found.</div>}
              </div>

              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3">
                <h2 className="text-xl font-bold text-yellow-400">{editingHackathonId ? 'Edit Hackathon' : 'Create Hackathon'}</h2>
                <input value={hackathonForm.title} onChange={(e) => setHackathonForm((current) => ({ ...current, title: e.target.value }))} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Title" />
                <input value={hackathonForm.slug} onChange={(e) => setHackathonForm((current) => ({ ...current, slug: e.target.value }))} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Slug" />
                <input value={hackathonForm.tagline} onChange={(e) => setHackathonForm((current) => ({ ...current, tagline: e.target.value }))} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Tagline" />
                <textarea value={hackathonForm.description} onChange={(e) => setHackathonForm((current) => ({ ...current, description: e.target.value }))} rows={4} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Description" />
                <textarea value={hackathonForm.theme} onChange={(e) => setHackathonForm((current) => ({ ...current, theme: e.target.value }))} rows={2} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Theme" />
                <div className="grid grid-cols-2 gap-3">
                  <input value={hackathonForm.format} onChange={(e) => setHackathonForm((current) => ({ ...current, format: e.target.value }))} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Format" />
                  <input value={hackathonForm.location} onChange={(e) => setHackathonForm((current) => ({ ...current, location: e.target.value }))} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Location" />
                </div>
                <input value={hackathonForm.age_requirement} onChange={(e) => setHackathonForm((current) => ({ ...current, age_requirement: e.target.value }))} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Age requirement" />
                <div className="grid grid-cols-2 gap-3">
                  <input type="datetime-local" value={hackathonForm.event_date} onChange={(e) => setHackathonForm((current) => ({ ...current, event_date: e.target.value }))} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" />
                  <input type="datetime-local" value={hackathonForm.application_deadline} onChange={(e) => setHackathonForm((current) => ({ ...current, application_deadline: e.target.value }))} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" />
                </div>
                <select value={hackathonForm.difficulty} onChange={(e) => setHackathonForm((current) => ({ ...current, difficulty: e.target.value }))} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                  <option value="beginner">Beginner</option>
                  <option value="intermediate">Intermediate</option>
                  <option value="advanced">Advanced</option>
                </select>
                <div className="grid grid-cols-1 gap-3">
                  <input value={hackathonForm.first_prize} onChange={(e) => setHackathonForm((current) => ({ ...current, first_prize: e.target.value }))} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Prize 1" />
                  <input value={hackathonForm.second_prize} onChange={(e) => setHackathonForm((current) => ({ ...current, second_prize: e.target.value }))} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Prize 2" />
                  <input value={hackathonForm.third_prize} onChange={(e) => setHackathonForm((current) => ({ ...current, third_prize: e.target.value }))} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Prize 3" />
                </div>
                <textarea value={hackathonForm.application_instructions} onChange={(e) => setHackathonForm((current) => ({ ...current, application_instructions: e.target.value }))} rows={4} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Application steps, one per line" />
                <input value={hackathonForm.image_url} onChange={(e) => setHackathonForm((current) => ({ ...current, image_url: e.target.value }))} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Image URL" />
                <label className="flex items-center gap-2 text-gray-300 text-sm">
                  <input type="checkbox" checked={hackathonForm.published} onChange={(e) => setHackathonForm((current) => ({ ...current, published: e.target.checked }))} />
                  Published
                </label>
                <label className="block text-sm text-gray-400">
                  Upload image
                  <input type="file" accept="image/*" className="mt-2 block w-full text-sm text-gray-300 file:mr-4 file:rounded-full file:border-0 file:bg-yellow-500 file:px-4 file:py-2 file:text-black file:font-semibold" onChange={(e) => uploadHackathonImage(e.target.files?.[0] || null)} />
                </label>
                {hackathonImageUploading && <div className="text-xs text-yellow-400">Uploading image...</div>}
                <div className="flex gap-3">
                  <button onClick={handleSaveHackathon} className="flex-1 bg-yellow-500 hover:bg-yellow-600 text-black py-3 rounded-lg font-bold">{editingHackathonId ? 'Save Hackathon' : 'Create Hackathon'}</button>
                  {editingHackathonId && <button onClick={startNewHackathon} className="px-4 py-3 border border-gray-600 rounded-lg text-gray-300">Cancel</button>}
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 xl:grid-cols-[1.1fr_0.9fr] gap-6">
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-4">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
                  <div>
                    <h2 className="text-xl font-bold text-yellow-400">Applications</h2>
                    <p className="text-sm text-gray-400">{selectedHackathon ? `Review applicants for ${selectedHackathon.title}` : 'Select a hackathon to review applications.'}</p>
                  </div>
                  <div className="flex gap-2 flex-wrap">
                    <input value={hackathonSearch} onChange={(e) => setHackathonSearch(e.target.value)} className="bg-gray-800 text-white px-4 py-2 rounded-lg border border-gray-600" placeholder="Search applicants" />
                    <select value={hackathonStatusFilter} onChange={(e) => setHackathonStatusFilter(e.target.value)} className="bg-gray-800 text-white px-4 py-2 rounded-lg border border-gray-600">
                      <option value="">All statuses</option>
                      <option value="new">New</option>
                      <option value="under_review">Under review</option>
                      <option value="reviewed">Reviewed</option>
                      <option value="shortlisted">Shortlisted</option>
                      <option value="accepted">Accepted</option>
                      <option value="rejected">Rejected</option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                  <div className="rounded-xl bg-gray-800 px-4 py-3 text-gray-200">Total: {hackathonApplicationStats.total || 0}</div>
                  <div className="rounded-xl bg-gray-800 px-4 py-3 text-gray-200">New: {hackathonApplicationStats.new || 0}</div>
                  <div className="rounded-xl bg-gray-800 px-4 py-3 text-gray-200">Shortlisted: {hackathonApplicationStats.shortlisted || 0}</div>
                  <div className="rounded-xl bg-gray-800 px-4 py-3 text-gray-200">Accepted: {hackathonApplicationStats.accepted || 0}</div>
                </div>

                <div className="rounded-2xl border border-yellow-400/10 bg-gray-950/40 p-4 space-y-3">
                  <h3 className="text-sm font-bold text-yellow-400 uppercase tracking-wide">Applicant Email</h3>
                  <input value={hackathonEmailForm.subject} onChange={(e) => setHackathonEmailForm((current) => ({ ...current, subject: e.target.value }))} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Subject" />
                  <textarea value={hackathonEmailForm.message} onChange={(e) => setHackathonEmailForm((current) => ({ ...current, message: e.target.value }))} rows={4} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Message" />
                  <div className="flex flex-wrap gap-3">
                    <button onClick={() => sendHackathonEmails(false)} className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 py-2 rounded-lg font-semibold text-sm">Email Selected</button>
                    <button onClick={() => sendHackathonEmails(true)} className="border border-yellow-400 text-yellow-400 px-4 py-2 rounded-lg text-sm">Email All Filtered</button>
                  </div>
                </div>

                <div className="space-y-3 max-h-[620px] overflow-y-auto pr-1">
                  {hackathonApplicationsLoading && <div className="text-gray-400">Loading applications...</div>}
                  {!hackathonApplicationsLoading && hackathonApplications.map((application) => (
                    <div key={application.id} className={`rounded-xl p-4 border ${selectedHackathonApplication?.id === application.id ? 'border-yellow-400 bg-gray-800' : 'border-gray-700 bg-gray-800/70'}`}>
                      <div className="flex gap-3 items-start">
                        <input type="checkbox" checked={selectedHackathonApplicationIds.includes(application.id)} onChange={() => toggleHackathonApplicationSelection(application.id)} className="mt-1" />
                        <button type="button" onClick={() => openHackathonApplication(application.id)} className="text-left flex-1">
                          <div className="text-white font-semibold">{application.applicant_name || `${application.first_name || ''} ${application.last_name || ''}`.trim()}</div>
                          <div className="text-gray-400 text-sm">{application.project_name} • {application.email}</div>
                          <div className="text-gray-500 text-xs mt-1">Submitted {formatHackathonDate(application.submitted_at)} • {application.status || 'new'}</div>
                        </button>
                        <select value={application.status || 'new'} onChange={(e) => updateHackathonApplicationStatus(application.id, e.target.value)} className="bg-gray-900 text-white px-3 py-2 rounded-lg border border-gray-600 text-sm">
                          <option value="new">New</option>
                          <option value="under_review">Under review</option>
                          <option value="reviewed">Reviewed</option>
                          <option value="shortlisted">Shortlisted</option>
                          <option value="accepted">Accepted</option>
                          <option value="rejected">Rejected</option>
                        </select>
                      </div>
                    </div>
                  ))}
                  {!hackathonApplicationsLoading && !hackathonApplications.length && <div className="text-gray-400">No applications found for this hackathon.</div>}
                </div>
              </div>

              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-4">
                <h2 className="text-xl font-bold text-yellow-400">Application Detail</h2>
                {!selectedHackathonApplication && <div className="text-gray-400">Select an application to inspect the project details, files, and email history.</div>}
                {selectedHackathonApplication && (
                  <div className="space-y-4">
                    <div>
                      <div className="text-white font-semibold text-lg">{selectedHackathonApplication.applicant_name}</div>
                      <div className="text-gray-400 text-sm">{selectedHackathonApplication.email} • {selectedHackathonApplication.phone_number || 'No phone'}</div>
                      <div className="text-gray-500 text-xs mt-1">Submitted {formatHackathonDate(selectedHackathonApplication.submitted_at)}</div>
                    </div>
                    <div className="rounded-xl bg-gray-800 p-4 space-y-2 text-sm text-gray-300">
                      <div><span className="text-yellow-400">Project:</span> {selectedHackathonApplication.project_name}</div>
                      <div><span className="text-yellow-400">Age:</span> {selectedHackathonApplication.age || 'Not provided'}</div>
                      <div><span className="text-yellow-400">Location:</span> {[selectedHackathonApplication.city, selectedHackathonApplication.country].filter(Boolean).join(', ') || 'Not provided'}</div>
                      <div><span className="text-yellow-400">Demo Link:</span> {selectedHackathonApplication.video_url ? <a href={selectedHackathonApplication.video_url} target="_blank" rel="noreferrer" className="text-yellow-300 underline">Open video</a> : 'None provided'}</div>
                    </div>
                    <div className="space-y-3 text-sm text-gray-300">
                      <div className="rounded-xl bg-gray-800 p-4"><div className="text-yellow-400 font-semibold mb-2">Robot Concept</div>{selectedHackathonApplication.robot_concept || 'No concept provided'}</div>
                      <div className="rounded-xl bg-gray-800 p-4"><div className="text-yellow-400 font-semibold mb-2">Project Description</div>{selectedHackathonApplication.project_description || 'No description provided'}</div>
                      <div className="rounded-xl bg-gray-800 p-4"><div className="text-yellow-400 font-semibold mb-2">Technology Stack</div>{selectedHackathonApplication.technologies_used || 'Not provided'}</div>
                      <div className="rounded-xl bg-gray-800 p-4"><div className="text-yellow-400 font-semibold mb-2">Electronics</div>{selectedHackathonApplication.electronics_concept || 'Not provided'}</div>
                      <div className="rounded-xl bg-gray-800 p-4"><div className="text-yellow-400 font-semibold mb-2">Software / AI</div>{selectedHackathonApplication.software_ai_concept || 'Not provided'}</div>
                      <div className="rounded-xl bg-gray-800 p-4"><div className="text-yellow-400 font-semibold mb-2">CAD / Design Notes</div>{selectedHackathonApplication.cad_design_info || 'Not provided'}</div>
                    </div>
                    <div>
                      <div className="text-sm font-bold text-yellow-400 uppercase tracking-wide mb-2">Files</div>
                      <div className="space-y-2">
                        {(selectedHackathonApplication.files || []).map((attachment) => (
                          <div key={attachment.id} className="rounded-xl bg-gray-800 px-4 py-3 flex items-center justify-between gap-3">
                            <div>
                              <div className="text-white text-sm font-medium">{attachment.original_filename}</div>
                              <div className="text-gray-500 text-xs">{getAttachmentTypeLabel(attachment)} • {formatAttachmentSize(attachment.file_size)}</div>
                            </div>
                            <div className="flex gap-2">
                              {(isImageAttachment(attachment) || isVideoAttachment(attachment)) && resolveAttachmentUrl(attachment, true) && (
                                <button type="button" onClick={() => adminDownloadAttachment(attachment, true)} className="text-xs px-3 py-2 rounded border border-gray-600 text-gray-300 hover:border-yellow-400">Preview</button>
                              )}
                              <button type="button" onClick={() => adminDownloadAttachment(attachment, false)} className="text-xs px-3 py-2 rounded border border-yellow-400 text-yellow-300 hover:bg-yellow-400 hover:text-black transition-colors">Download</button>
                            </div>
                          </div>
                        ))}
                        {!(selectedHackathonApplication.files || []).length && <div className="text-gray-500 text-sm">No files uploaded.</div>}
                      </div>
                    </div>
                    <div>
                      <div className="text-sm font-bold text-yellow-400 uppercase tracking-wide mb-2">Communication History</div>
                      <div className="space-y-2 max-h-[220px] overflow-y-auto pr-1">
                        {(selectedHackathonApplication.communication_history || []).map((entry) => (
                          <div key={entry.id} className="rounded-xl bg-gray-800 px-4 py-3 text-sm">
                            <div className="text-white font-medium">{entry.subject}</div>
                            <div className="text-gray-400 mt-1">{entry.message}</div>
                            <div className="text-gray-500 text-xs mt-2">{formatHackathonDate(entry.sent_at)} • {entry.status || 'sent'} • {entry.sent_by_name || 'Admin'}</div>
                          </div>
                        ))}
                        {!(selectedHackathonApplication.communication_history || []).length && <div className="text-gray-500 text-sm">No emails logged yet.</div>}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>
        )}

        {activeTab === 'classes' && (
          <section className="grid grid-cols-1 xl:grid-cols-3 gap-6">
            <div className="xl:col-span-2 bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3 max-h-[760px] overflow-y-auto pr-1">
              {classes.map((entry) => (
                <div key={entry.id} className="bg-gray-800 rounded-xl p-4">
                  <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                    <div>
                      <div className="text-white font-semibold">{entry.name}</div>
                      <div className="text-gray-400 text-sm">{entry.course_title || entry.course_id} • {entry.teacher_name || entry.teacher_id}</div>
                      <div className="text-gray-500 text-xs mt-1">{entry.date} • {entry.start_time} - {entry.end_time} • {entry.status}</div>
                    </div>
                    <div className="flex gap-2 flex-wrap">
                      <button onClick={() => { setSelectedClass(entry); setClassForm({ ...defaultClassForm, ...entry, student_ids: entry.student_ids || [] }); }} className="border border-yellow-400 text-yellow-400 px-3 py-2 rounded-lg text-sm">Edit</button>
                      <button onClick={() => cancelClass(entry.id)} className="bg-orange-600 hover:bg-orange-700 text-white px-3 py-2 rounded-lg text-sm">Cancel</button>
                      <button onClick={() => deleteClass(entry.id)} className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg text-sm">Delete</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3">
              <h2 className="text-xl font-bold text-yellow-400">{selectedClass ? 'Edit Class' : 'Create Class'}</h2>
              <input value={classForm.name} onChange={(e) => setClassForm({ ...classForm, name: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Class name" />
              <select value={classForm.teacher_id} onChange={(e) => setClassForm({ ...classForm, teacher_id: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                <option value="">Select teacher</option>
                {teachers.map((teacher) => <option key={teacher.id} value={teacher.id}>{teacher.name}</option>)}
              </select>
              <select value={classForm.course_id} onChange={(e) => setClassForm({ ...classForm, course_id: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                <option value="">Select course</option>
                {courses.map((course) => <option key={course.id} value={course.id}>{course.title}</option>)}
              </select>
              <div className="grid grid-cols-3 gap-3">
                <input value={classForm.date} onChange={(e) => setClassForm({ ...classForm, date: e.target.value })} type="date" className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" />
                <input value={classForm.start_time} onChange={(e) => setClassForm({ ...classForm, start_time: e.target.value })} type="time" className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" />
                <input value={classForm.end_time} onChange={(e) => setClassForm({ ...classForm, end_time: e.target.value })} type="time" className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" />
              </div>
              <textarea value={classForm.meeting_link} onChange={(e) => setClassForm({ ...classForm, meeting_link: e.target.value })} rows={2} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Meeting link" />
              <div className="bg-gray-800 rounded-xl p-4">
                <div className="text-yellow-400 font-semibold mb-3">Assign Students</div>
                <div className="max-h-48 overflow-y-auto space-y-2">
                  {students.map((student) => (
                    <label key={student.id} className="flex items-center gap-2 text-sm text-gray-300">
                      <input
                        type="checkbox"
                        checked={(classForm.student_ids || []).includes(student.id)}
                        onChange={() => setClassForm((current) => ({
                          ...current,
                          student_ids: (current.student_ids || []).includes(student.id)
                            ? current.student_ids.filter((item) => item !== student.id)
                            : [...(current.student_ids || []), student.id],
                        }))}
                      />
                      <span>{student.name}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div className="flex gap-3">
                <button onClick={handleSaveClass} className="flex-1 bg-yellow-500 hover:bg-yellow-600 text-black py-3 rounded-lg font-bold">{selectedClass ? 'Save Class' : 'Create Class'}</button>
                {selectedClass && <button onClick={() => { setSelectedClass(null); setClassForm(defaultClassForm); }} className="px-4 py-3 border border-gray-600 rounded-lg text-gray-300">Close</button>}
              </div>
            </div>
          </section>
        )}

        {activeTab === 'enrollments' && (
          <section className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3">
            {enrollments.map((entry) => (
              <div key={entry.id} className="bg-gray-800 rounded-xl p-4 flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                <div>
                  <div className="text-white font-semibold">{entry.student_name || entry.student_email}</div>
                  <div className="text-gray-400 text-sm">{entry.course_title} • {entry.program_label || entry.program_type || 'Program pending'}</div>
                  <div className="text-gray-500 text-xs mt-1">Status: {String(entry.status || 'pending_review').replaceAll('_', ' ')} • Teacher: {entry.teacher_name || entry.teacher_id || 'Unassigned'}</div>
                  {entry.registration_profile?.educational_information?.educational_goals && <div className="text-gray-300 text-sm mt-2">Goal: {entry.registration_profile.educational_information.educational_goals}</div>}
                </div>
                <div className="flex gap-2 flex-wrap">
                  <button onClick={() => processEnrollment(entry.id, 'approve', entry)} className="bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded-lg text-sm">Approve</button>
                  <button onClick={() => processEnrollment(entry.id, 'enroll', entry)} className="bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded-lg text-sm">Enroll</button>
                  <button onClick={() => processEnrollment(entry.id, 'waitlist', entry)} className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-lg text-sm">Waitlist</button>
                  <button onClick={() => processEnrollment(entry.id, 'request-info', entry)} className="bg-orange-600 hover:bg-orange-700 text-white px-3 py-2 rounded-lg text-sm">Request Info</button>
                  <button onClick={() => processEnrollment(entry.id, 'reject', entry)} className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg text-sm">Reject</button>
                </div>
              </div>
            ))}
          </section>
        )}

        {activeTab === 'communication' && (
          <section className="space-y-6">
            <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-4">
              <h2 className="text-xl font-bold text-yellow-400">Direct Conversations</h2>
              <p className="text-sm text-gray-400">Send private text, image, video, or document messages directly to one user and continue the thread.</p>
              <div className="grid grid-cols-1 xl:grid-cols-[320px_1fr] gap-4">
                <div className="space-y-3 rounded-xl border border-gray-700 bg-gray-950/60 p-4">
                  <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wide">Recipient Role</label>
                  <select
                    value={conversationRecipientRoleFilter}
                    onChange={(e) => setConversationRecipientRoleFilter(e.target.value)}
                    className="w-full bg-gray-800 text-white px-3 py-2.5 rounded-lg border border-gray-600"
                  >
                    <option value="employee">Employee</option>
                    <option value="student">Student</option>
                    <option value="teacher">Teacher</option>
                    <option value="admin">Admin</option>
                  </select>

                  <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wide">Recipient</label>
                  <select
                    value={conversationRecipientId}
                    onChange={(e) => setConversationRecipientId(e.target.value)}
                    className="w-full bg-gray-800 text-white px-3 py-2.5 rounded-lg border border-gray-600"
                  >
                    <option value="">Select a user</option>
                    {conversationRecipients.map((entry) => (
                      <option key={entry.id} value={entry.id}>{entry.name || entry.email} ({entry.email})</option>
                    ))}
                  </select>

                  <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wide">Subject</label>
                  <input
                    value={conversationSubjectDraft}
                    onChange={(e) => setConversationSubjectDraft(e.target.value)}
                    className="w-full bg-gray-800 text-white px-3 py-2.5 rounded-lg border border-gray-600 text-sm"
                    placeholder="Direct message subject"
                  />

                  <textarea
                    value={conversationStartDraft}
                    onChange={(e) => setConversationStartDraft(e.target.value)}
                    rows={3}
                    className="w-full bg-gray-800 text-white px-3 py-2 rounded-lg border border-gray-600 text-sm"
                    placeholder="Initial private message"
                  />

                  <div>
                    <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">Attachments</label>
                    <input
                      type="file"
                      multiple
                      onChange={(e) => handleUploadConversationStartAttachments(e.target.files)}
                      className="w-full text-xs text-gray-300 file:mr-3 file:rounded-md file:border-0 file:bg-yellow-500 file:px-3 file:py-2 file:text-xs file:font-semibold file:text-black hover:file:bg-yellow-400"
                    />
                    {conversationStartAttachmentUploading && <div className="text-xs text-gray-400 mt-1">Uploading attachments...</div>}
                  </div>

                  {conversationStartAttachmentDraft.length > 0 && (
                    <div className="space-y-2 max-h-32 overflow-y-auto pr-1">
                      {conversationStartAttachmentDraft.map((att) => (
                        <div key={att.id} className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 flex items-start justify-between gap-2">
                          <div className="min-w-0">
                            <div className="text-sm text-white truncate">{att.filename}</div>
                            <div className="text-[11px] text-gray-400">{formatAttachmentSize(att.size)} • {getAttachmentTypeLabel(att)}</div>
                          </div>
                          <button type="button" onClick={() => setConversationStartAttachmentDraft((current) => current.filter((row) => row.id !== att.id))} className="text-[11px] px-2 py-1 rounded border border-red-600 text-red-300 hover:bg-red-900/30">Remove</button>
                        </div>
                      ))}
                    </div>
                  )}

                  <button onClick={handleStartDirectConversation} className="w-full bg-yellow-500 hover:bg-yellow-600 text-black py-2.5 rounded-lg font-bold">Send And Open Conversation</button>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-3">
                  <div className="space-y-2 max-h-[560px] overflow-y-auto pr-1">
                    <input
                      value={employeeConversationSearch}
                      onChange={(e) => setEmployeeConversationSearch(e.target.value)}
                      className="w-full bg-gray-800 text-white px-3 py-2 rounded-lg border border-gray-600 text-sm"
                      placeholder="Search conversations"
                    />
                    {employeeInbox
                      .filter((thread) => {
                        const term = employeeConversationSearch.trim().toLowerCase();
                        if (!term) return true;
                        const haystack = [thread.display_name, thread.title, thread.last_message_preview]
                          .filter(Boolean)
                          .join(' ')
                          .toLowerCase();
                        return haystack.includes(term);
                      })
                      .slice(0, 150)
                      .map((thread) => (
                        <button
                          key={thread.id}
                          type="button"
                          onClick={() => handleOpenEmployeeConversation(thread.id)}
                          className={`w-full text-left bg-gray-800 rounded-xl p-3 border ${selectedEmployeeConversationId === thread.id ? 'border-yellow-400' : 'border-gray-700 hover:border-yellow-500/60'}`}
                        >
                          <div className="flex justify-between gap-2 text-sm">
                            <div className="text-white font-medium line-clamp-1">{thread.display_name || thread.title || 'Conversation'}</div>
                            {thread.unread_count > 0 && <span className="text-[10px] bg-yellow-500 text-black px-2 py-0.5 rounded-full font-bold">{thread.unread_count}</span>}
                          </div>
                          <div className="text-xs text-gray-400 mt-1 line-clamp-2">{thread.last_message_preview || 'No messages yet'}</div>
                        </button>
                      ))}
                    {employeeInbox.length === 0 && <div className="text-sm text-gray-500">No conversations yet.</div>}
                  </div>

                  <div className="bg-gray-800 rounded-xl border border-gray-700 p-3 space-y-3">
                    {!selectedEmployeeConversationId ? (
                      <div className="text-sm text-gray-500">Select or start a conversation to view messages.</div>
                    ) : (
                      <>
                        <div className="flex flex-wrap items-center justify-between gap-2">
                          <div>
                            <div className="text-white font-semibold">{employeeConversationDetail?.display_name || employeeConversationDetail?.title || 'Conversation'}</div>
                            <div className="text-xs text-gray-400 mt-1">{(employeeConversationDetail?.participant_profiles || []).map((p) => p.name || p.email).join(', ')}</div>
                          </div>
                          <div className="flex gap-2">
                            <button onClick={() => handleSetEmployeeMessageStatus(selectedEmployeeConversationId, true)} className="px-3 py-1.5 rounded border border-blue-600 text-blue-300 text-xs">Pin</button>
                            <button onClick={() => handleSetEmployeeMessageStatus(selectedEmployeeConversationId, false)} className="px-3 py-1.5 rounded border border-gray-600 text-gray-200 text-xs">Unpin</button>
                          </div>
                        </div>

                        <div className="space-y-2 max-h-[360px] overflow-y-auto pr-1">
                          {(employeeConversationMessages || []).length === 0 ? (
                            <div className="text-sm text-gray-500">No messages yet.</div>
                          ) : (
                            (employeeConversationMessages || []).map((msg) => (
                              <div key={msg.id} className="bg-gray-900 rounded-xl border border-gray-700 p-3">
                                <div className="text-xs text-yellow-300 font-semibold">{msg.sender_name || 'User'} • {new Date(msg.created_at).toLocaleString()}</div>
                                {msg.message && <div className="text-sm text-gray-100 mt-1 whitespace-pre-wrap">{msg.message}</div>}
                                {(msg.attachments || []).length > 0 && (
                                  <div className="mt-2 space-y-2">
                                    {(msg.attachments || []).map((attachment) => (
                                      <div key={attachment.id} className="rounded-lg border border-gray-700 bg-black/20 p-2">
                                        <div className="flex flex-wrap items-center justify-between gap-2">
                                          <div className="min-w-0">
                                            <div className="text-xs text-yellow-300 font-semibold">{getAttachmentTypeLabel(attachment)}</div>
                                            <div className="text-xs text-white truncate">{attachment.filename}</div>
                                            <div className="text-[11px] text-gray-400">{formatAttachmentSize(attachment.size)} • {formatAttachmentDate(attachment.uploaded_at)}</div>
                                          </div>
                                          <div className="flex gap-1.5">
                                            {(isImageAttachment(attachment) || isVideoAttachment(attachment)) && resolveAttachmentUrl(attachment, true) && (
                                              <button type="button" onClick={() => adminDownloadAttachment(attachment, true)} className="text-[10px] px-2 py-0.5 rounded border border-gray-600 text-gray-300 hover:border-yellow-400">Preview</button>
                                            )}
                                            <button type="button" onClick={() => adminDownloadAttachment(attachment, false)} className="text-[10px] px-2 py-0.5 rounded border border-gray-600 text-yellow-300 hover:border-yellow-400">Download</button>
                                          </div>
                                        </div>
                                        {isImageAttachment(attachment) && resolveAttachmentUrl(attachment, true) && (
                                          <img src={resolveAttachmentUrl(attachment, true)} alt={attachment.filename || 'Attachment'} className="mt-2 rounded-md max-h-48 w-auto border border-gray-700" />
                                        )}
                                        {isVideoAttachment(attachment) && resolveAttachmentUrl(attachment, true) && (
                                          <video controls preload="metadata" className="mt-2 rounded-md max-h-56 w-full border border-gray-700 bg-black">
                                            <source src={resolveAttachmentUrl(attachment, true)} type={attachment.content_type || 'video/mp4'} />
                                          </video>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ))
                          )}
                        </div>

                        {conversationReplyAttachmentDraft.length > 0 && (
                          <div className="flex flex-wrap gap-2">
                            {conversationReplyAttachmentDraft.map((att) => (
                              <div key={att.id} className="flex items-center gap-1.5 bg-gray-700 rounded-lg px-2 py-1 text-xs text-gray-200">
                                <span className="truncate max-w-[120px]">{att.filename}</span>
                                <button type="button" onClick={() => setConversationReplyAttachmentDraft((c) => c.filter((a) => a.id !== att.id))} className="text-red-400 hover:text-red-300 ml-1">x</button>
                              </div>
                            ))}
                          </div>
                        )}

                        <textarea
                          value={employeeConversationReply}
                          onChange={(e) => setEmployeeConversationReply(e.target.value)}
                          rows={3}
                          className="w-full bg-gray-900 text-white px-3 py-2 rounded-lg border border-gray-600 text-sm"
                          placeholder="Reply to this conversation"
                        />
                        <div className="flex flex-wrap items-center gap-3">
                          <button onClick={handleReplyEmployeeMessage} className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 py-2 rounded-lg text-sm font-semibold">Send Reply</button>
                          <label className="cursor-pointer text-xs text-gray-300 border border-gray-600 px-3 py-2 rounded-lg hover:border-yellow-400">
                            {conversationReplyAttachmentUploading ? 'Uploading...' : '+ Attach File'}
                            <input type="file" multiple className="hidden" disabled={conversationReplyAttachmentUploading} onChange={(e) => handleUploadConversationReplyAttachments(e.target.files)} />
                          </label>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3">
                <h2 className="text-xl font-bold text-yellow-400">Broadcast Message</h2>
                <input value={messageForm.subject} onChange={(e) => setMessageForm({ ...messageForm, subject: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Subject" />
                <textarea value={messageForm.content} onChange={(e) => setMessageForm({ ...messageForm, content: e.target.value })} rows={5} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Message content" />
                <select value={messageForm.recipient_type} onChange={(e) => setMessageForm({ ...messageForm, recipient_type: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                  <option value="all_students">All Students</option>
                  <option value="all_teachers">All Teachers</option>
                  <option value="all_users">All Users</option>
                  <option value="specific_course">Specific Course</option>
                  <option value="specific_class">Specific Class</option>
                  <option value="individual_user">Individual User</option>
                </select>
                {messageForm.recipient_type === 'specific_course' && <select value={messageForm.course_id} onChange={(e) => setMessageForm({ ...messageForm, course_id: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600"><option value="">Select course</option>{courses.map((course) => <option key={course.id} value={course.id}>{course.title}</option>)}</select>}
                {messageForm.recipient_type === 'specific_class' && <select value={messageForm.class_id} onChange={(e) => setMessageForm({ ...messageForm, class_id: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600"><option value="">Select class</option>{classes.map((entry) => <option key={entry.id} value={entry.id}>{entry.name}</option>)}</select>}
                {messageForm.recipient_type === 'individual_user' && <select value={messageForm.user_id} onChange={(e) => setMessageForm({ ...messageForm, user_id: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600"><option value="">Select user</option>{users.map((entry) => <option key={entry.id} value={entry.id}>{entry.name} ({entry.email})</option>)}</select>}
                <div className="flex gap-4 text-sm text-gray-300">
                  <label className="flex items-center gap-2"><input type="checkbox" checked={messageForm.channels.includes('platform')} onChange={() => toggleMessageChannel('platform')} />Platform</label>
                  <label className="flex items-center gap-2"><input type="checkbox" checked={messageForm.channels.includes('email')} onChange={() => toggleMessageChannel('email')} />Email</label>
                </div>
                <button onClick={saveMessage} className="w-full bg-yellow-500 hover:bg-yellow-600 text-black py-3 rounded-lg font-bold">Send Message</button>
              </div>
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3">
              <h2 className="text-xl font-bold text-yellow-400">Newsletter</h2>
              <input value={newsletterForm.subject} onChange={(e) => setNewsletterForm({ ...newsletterForm, subject: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Email subject" />
              <textarea value={newsletterForm.content} onChange={(e) => setNewsletterForm({ ...newsletterForm, content: e.target.value })} rows={6} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Rich text HTML or formatted content" />
              <select value={newsletterForm.recipients} onChange={(e) => setNewsletterForm({ ...newsletterForm, recipients: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600">
                <option value="all_users">All Users</option>
                <option value="students_only">Students Only</option>
                <option value="teachers_only">Teachers Only</option>
                <option value="selected_groups">Selected Groups</option>
              </select>
              <div className="grid grid-cols-2 gap-3 text-sm text-gray-300">
                <label className="flex items-center gap-2"><input type="checkbox" checked={newsletterForm.preview_mode} onChange={(e) => setNewsletterForm({ ...newsletterForm, preview_mode: e.target.checked })} />Preview Mode</label>
                <label className="flex items-center gap-2"><input type="checkbox" checked={newsletterForm.send_immediately} onChange={(e) => setNewsletterForm({ ...newsletterForm, send_immediately: e.target.checked })} />Send Immediately</label>
              </div>
              <input type="datetime-local" value={newsletterForm.scheduled_for} onChange={(e) => setNewsletterForm({ ...newsletterForm, scheduled_for: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" />
              <button onClick={saveNewsletter} className="w-full bg-yellow-500 hover:bg-yellow-600 text-black py-3 rounded-lg font-bold">Save Newsletter</button>
              <div className="max-h-56 overflow-y-auto space-y-2 pt-3 border-t border-gray-700">
                {newsletters.map((item) => (
                  <div key={item.id} className="bg-gray-800 rounded-lg p-3 text-sm">
                    <div className="text-white font-medium">{item.subject}</div>
                    <div className="text-gray-400">Sent: {item.analytics?.sent || 0} • Delivered: {item.analytics?.delivered || 0} • Failed: {item.analytics?.failed || 0}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3">
              <h2 className="text-xl font-bold text-yellow-400">Announcements</h2>
              <input value={announcementForm.title} onChange={(e) => setAnnouncementForm({ ...announcementForm, title: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Announcement title" />
              <textarea value={announcementForm.content} onChange={(e) => setAnnouncementForm({ ...announcementForm, content: e.target.value })} rows={5} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Announcement content" />
              <div className="grid grid-cols-3 gap-2 text-sm text-gray-300">
                {['homepage', 'student-dashboard', 'teacher-dashboard'].map((placement) => (
                  <label key={placement} className="flex items-center gap-2"><input type="checkbox" checked={announcementForm.placements.includes(placement)} onChange={() => setAnnouncementForm((current) => ({ ...current, placements: current.placements.includes(placement) ? current.placements.filter((item) => item !== placement) : [...current.placements, placement] }))} />{placement}</label>
                ))}
              </div>
              <select value={announcementForm.priority} onChange={(e) => setAnnouncementForm({ ...announcementForm, priority: e.target.value })} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600"><option value="information">Information</option><option value="important">Important</option><option value="urgent">Urgent</option></select>
              <div className="grid grid-cols-2 gap-3">
                <input type="date" value={announcementForm.start_date} onChange={(e) => setAnnouncementForm({ ...announcementForm, start_date: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" />
                <input type="date" value={announcementForm.end_date} onChange={(e) => setAnnouncementForm({ ...announcementForm, end_date: e.target.value })} className="bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" />
              </div>
              <button onClick={saveAnnouncement} className="w-full bg-yellow-500 hover:bg-yellow-600 text-black py-3 rounded-lg font-bold">Create Announcement</button>
              <div className="max-h-56 overflow-y-auto space-y-2 pt-3 border-t border-gray-700">
                {announcements.map((item) => (
                  <div key={item.id} className="bg-gray-800 rounded-lg p-3 text-sm">
                    <div className="text-white font-medium">{item.title}</div>
                    <div className="text-gray-400">{item.priority} • {(item.placements || []).join(', ')}</div>
                  </div>
                ))}
              </div>
            </div>
            </div>
          </section>
        )}

        {activeTab === 'attendance' && (
          <section className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6">
              <h2 className="text-xl font-bold text-yellow-400 mb-4">Attendance Summary</h2>
              <div className="space-y-2 text-gray-300">
                <div>Total Records: <span className="text-white">{attendance.summary?.total_records || 0}</span></div>
                <div>Attendance Rate: <span className="text-white">{attendance.summary?.attendance_rate || 0}%</span></div>
              </div>
            </div>
            <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6">
              <h2 className="text-xl font-bold text-yellow-400 mb-4">By Teacher</h2>
              <div className="space-y-2 text-sm text-gray-300 max-h-72 overflow-y-auto">
                {(attendance.by_teacher || []).map((item) => <div key={item.teacher_id}>{item.teacher_name}: {item.records}</div>)}
              </div>
            </div>
            <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6">
              <h2 className="text-xl font-bold text-yellow-400 mb-4">By Course</h2>
              <div className="space-y-2 text-sm text-gray-300 max-h-72 overflow-y-auto">
                {(attendance.by_course || []).map((item) => <div key={item.course_id}>{item.course_title}: {item.records}</div>)}
              </div>
            </div>
          </section>
        )}

        {activeTab === 'finance' && (
          <section className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6"><div className="text-gray-400">Total Paid</div><div className="text-3xl font-bold text-yellow-400 mt-2">${Number(payments.summary?.total_paid || 0).toFixed(2)}</div></div>
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6"><div className="text-gray-400">Refunds</div><div className="text-3xl font-bold text-yellow-400 mt-2">${Number(payments.summary?.refunds || 0).toFixed(2)}</div></div>
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6"><div className="text-gray-400">Outstanding Balances</div><div className="text-3xl font-bold text-yellow-400 mt-2">${Number(payments.summary?.outstanding_balances || 0).toFixed(2)}</div></div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6"><h2 className="text-xl font-bold text-yellow-400 mb-4">Monthly Revenue</h2><div className="space-y-2 text-sm text-gray-300">{(payments.summary?.monthly_revenue || []).map((item) => <div key={item.month}>{item.month}: ${Number(item.amount || 0).toFixed(2)}</div>)}</div></div>
              <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6"><h2 className="text-xl font-bold text-yellow-400 mb-4">Program Revenue</h2><div className="space-y-2 text-sm text-gray-300">{(payments.summary?.program_revenue || []).map((item) => <div key={item.name}>{item.name}: ${Number(item.amount || 0).toFixed(2)}</div>)}</div></div>
            </div>
            <div className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6">
              <h2 className="text-xl font-bold text-yellow-400 mb-4">Payment Transactions</h2>
              <div className="overflow-x-auto">
                <table className="w-full text-left text-sm">
                  <thead className="text-gray-400 border-b border-gray-700">
                    <tr><th className="py-2 pr-3">Student</th><th className="py-2 pr-3">Course / Product</th><th className="py-2 pr-3">Amount</th><th className="py-2 pr-3">Provider</th><th className="py-2 pr-3">Status</th><th className="py-2">Date</th></tr>
                  </thead>
                  <tbody>
                    {paymentTransactions.map((transaction) => (
                      <tr key={transaction.id || transaction.session_id} className="border-b border-gray-800 text-gray-300">
                        <td className="py-3 pr-3">{transaction.student_name || transaction.student_email || 'Unknown'}</td>
                        <td className="py-3 pr-3">{transaction.course_name || transaction.product_type || 'Payment'}</td>
                        <td className="py-3 pr-3">{transaction.currency || 'CAD'} ${Number(transaction.amount || 0).toFixed(2)}</td>
                        <td className="py-3 pr-3 uppercase">{transaction.provider || 'stripe'}</td>
                        <td className="py-3 pr-3 capitalize">{String(transaction.payment_status || transaction.transaction_status || 'unknown').replaceAll('_', ' ')}</td>
                        <td className="py-3">{transaction.created_at ? new Date(transaction.created_at).toLocaleDateString() : 'Unknown'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {paymentTransactions.length === 0 && <p className="text-gray-400 mt-3">No payment transactions found.</p>}
            </div>
          </section>
        )}

        {activeTab === 'content' && (
          <section className="grid grid-cols-1 xl:grid-cols-2 gap-6">
            {contentSections.map((section) => (
              <div key={section} className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3">
                <h2 className="text-xl font-bold text-yellow-400 capitalize">{section.replace(/_/g, ' ')}</h2>
                <input value={contentDrafts[section]?.title || ''} onChange={(e) => setContentDrafts((current) => ({ ...current, [section]: { ...(current[section] || {}), title: e.target.value } }))} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Title" />
                <textarea value={contentDrafts[section]?.body || ''} onChange={(e) => setContentDrafts((current) => ({ ...current, [section]: { ...(current[section] || {}), body: e.target.value } }))} rows={6} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600" placeholder="Managed content" />
                <button onClick={() => saveContentSection(section)} className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 py-3 rounded-lg font-bold">Save Section</button>
              </div>
            ))}
          </section>
        )}

        {activeTab === 'settings' && (
          <section className="grid grid-cols-1 xl:grid-cols-2 gap-6">
            {[
              ['school_information', 'School Information'],
              ['contact_information', 'Contact Information'],
              ['email_settings', 'Email Settings'],
              ['enrollment_settings', 'Enrollment Settings'],
              ['certificate_settings', 'Certificate Settings'],
              ['branding', 'Branding'],
            ].map(([key, label]) => (
              <div key={key} className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3">
                <h2 className="text-xl font-bold text-yellow-400">{label}</h2>
                <textarea value={JSON.stringify(settings[key] || {}, null, 2)} onChange={(e) => {
                  try {
                    setSettings({ ...settings, [key]: JSON.parse(e.target.value || '{}') });
                  } catch {
                    setSettings({ ...settings, [key]: settings[key] || {} });
                  }
                }} rows={8} className="w-full bg-gray-800 text-white px-4 py-3 rounded-lg border border-gray-600 font-mono text-sm" />
              </div>
            ))}
            <div className="xl:col-span-2">
              <button onClick={saveSettings} className="bg-yellow-500 hover:bg-yellow-600 text-black px-6 py-3 rounded-lg font-bold">Save Settings</button>
            </div>
          </section>
        )}

        {activeTab === 'audit' && (
          <section className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6 space-y-3 max-h-[760px] overflow-y-auto pr-1">
            {auditLogs.map((entry) => (
              <div key={entry.id} className="bg-gray-800 rounded-xl p-4">
                <div className="text-white font-semibold">{entry.action}</div>
                <div className="text-gray-400 text-sm">{entry.admin_name} • {entry.target_type} • {entry.target_id || 'n/a'}</div>
                <div className="text-gray-500 text-xs mt-1">{entry.timestamp ? new Date(entry.timestamp).toLocaleString() : 'recently'}</div>
              </div>
            ))}
          </section>
        )}

        {activeTab === 'certificates' && (
          <section className="bg-gray-900 border border-yellow-400/20 rounded-2xl p-6">
            <h2 className="text-2xl font-bold text-yellow-400 mb-4">Certificate Management</h2>
            <p className="text-gray-300 mb-6">Use the existing certificate administration tools to create templates, issue certificates, revoke or reissue credentials, and verify issued records.</p>
            <div className="flex gap-3 flex-wrap">
              <button onClick={() => onPageChange('admin-certificates')} className="bg-yellow-500 hover:bg-yellow-600 text-black px-5 py-3 rounded-lg font-bold">Open Certificates Admin</button>
              <button onClick={() => onPageChange('certificate-verification')} className="border border-yellow-400 text-yellow-400 px-5 py-3 rounded-lg">Open Verification Page</button>
            </div>
          </section>
        )}
      </div>
    </div>
  );
}